/**
 * Plugin to handle the Google Map
 */

(function ($) {
  'use strict';

  var pluginName = 'trademarkMap',
    namespace = 'plugin_' + pluginName;

  /**
   * The Plugin constructor
   * @constructor
   * @param {HTMLElement} element The element that will be monitored
   */
  function Plugin(element) {
    this.element = $(element);
    this.options = JSON.parse(this.element.attr('data-section-settings'));
    this.locations = [];
    this.markers = [];

    this.element.on('click', '[data-action="toggle-store"]', this._toggleStore.bind(this));
    this.element.on('click', '.featured-map__store-item', this._activateStore.bind(this));
    this.element.on('shopify:block:select', this._blockSelected.bind(this));

    this.googleMapContainer = this.element.find('.featured-map__gmap').get(0);

    if (this.options['apiKey'] && this.options['mapAddresses'].length > 0) {
      var $script = $('script[src*="' + this.options['apiKey'] + '&"]'),
        self = this;

      if ($script.length === 0) {
        $.getScript(
          'https://maps.googleapis.com/maps/api/js?key=' + this.options['apiKey']
        ).then(function() {
          self._initMap();
        });
      } else {
        this._initMap();
      }
    }

    $(window).on('resize.trademarkMap', this._repositionMap.bind(this));
  }

  Plugin.prototype.destroy = function() {
    $(window).off('resize.trademarkMap');
  };

  Plugin.prototype._blockSelected = function(event) {
    this._selectStore($(event.target));
  };

  Plugin.prototype._toggleStore = function(event) {
    this._selectStore($(event.currentTarget).closest('.featured-map__store-item'));
  };

  Plugin.prototype._activateStore = function(event) {
    this._selectStore($(event.currentTarget));
  };

  Plugin.prototype._selectStore = function(storeElement) {
    storeElement.addClass('featured-map__store-item--active');

    if (window.matchMedia('screen and (max-width: 800px)').matches) {
      storeElement.find('.featured-map__store-inner').slideDown()
        .end().find('.plus-button').addClass('plus-button--active');

      storeElement.siblings('.featured-map__store-item--active')
        .find('.featured-map__store-inner').slideUp()
        .end().find('.plus-button').removeClass('plus-button--active');
    }

    storeElement.siblings('.featured-map__store-item--active').removeClass('featured-map__store-item--active');

    this._repositionMap();
    this._setNewCenter(storeElement.attr('data-store-index'));
  };

  Plugin.prototype._initMap = function() {
    var geocoder = new google.maps.Geocoder(),
      self = this;

    var mapOptions = {
      zoom: self.options['zoom'],
      draggable: false,
      clickableIcons: false,
      scrollwheel: false,
      disableDoubleClickZoom: true,
      disableDefaultUI: true
    };

    this.googleMap = new google.maps.Map(this.googleMapContainer, mapOptions);
    var styledMapType = new google.maps.StyledMapType(JSON.parse(this.element.find('[data-gmap-style]').html()));

    this.googleMap.mapTypes.set('styled_map', styledMapType);
    this.googleMap.setMapTypeId('styled_map');

    this._repositionMap();

    // We need to geocode each addresses individually
    this.options['mapAddresses'].forEach(function(address, index) {
      geocoder.geocode({ address: address }, function(results, status) {
        if (status !== google.maps.GeocoderStatus.OK) {
          if (Shopify.designMode) {

          }
        } else {
          if (index === 0) {
            self.googleMap.setCenter(results[0].geometry.location);
          }

          self.locations[index] = results[0].geometry.location;

          var icon = {
            path: "M32.7374478,5.617 C29.1154478,1.995 24.2994478,0 19.1774478,0 C14.0544478,0 9.23944778,1.995 5.61744778,5.617 C-1.08555222,12.319 -1.91855222,24.929 3.81344778,32.569 L19.1774478,54.757 L34.5184478,32.6 C40.2734478,24.929 39.4404478,12.319 32.7374478,5.617 Z M19.3544478,26 C15.4954478,26 12.3544478,22.859 12.3544478,19 C12.3544478,15.141 15.4954478,12 19.3544478,12 C23.2134478,12 26.3544478,15.141 26.3544478,19 C26.3544478,22.859 23.2134478,26 19.3544478,26 Z",
            fillColor: index === 0 ? self.options['markerActiveColor'] : self.options['markerColor'],
            fillOpacity: 1,
            anchor: new google.maps.Point(15,55),
            strokeWeight: 0,
            scale: window.matchMedia('screen and (max-width: 559px)').matches ? 0.5 : (index === 0 ? 0.7 : 0.5)
          };

          self.markers[index] = new google.maps.Marker({
            map: self.googleMap,
            position: results[0].geometry.location,
            icon: icon
          });
        }
      });
    });
  };

  Plugin.prototype._setNewCenter = function(index) {
    var self = this,
      indexAsInt = parseInt(index);

    this.googleMap.panTo(this.locations[indexAsInt]);

    this.markers.forEach(function(marker, markerIndex) {
      if (markerIndex === indexAsInt) {
        marker.icon.fillColor = self.options['markerActiveColor'];
        marker.icon.scale = window.matchMedia('screen and (max-width: 559px)').matches ? 0.5 : 0.7;
      } else {
        marker.icon.fillColor = self.options['markerColor'];
        marker.icon.scale = 0.5;
      }

      marker.setMap(self.googleMap);
    });
  };

  /**
   * Reposition the GMap container (which allows to re-use it on mobile and desktop)
   *
   * @private
   */
  Plugin.prototype._repositionMap = function() {
    var container = null;

    if (window.matchMedia('screen and (min-width: 801px)').matches) {
      container = this.element.find('.featured-map__map-container--desktop');
    } else {
      container = this.element.find('.featured-map__store-item--active .featured-map__map-container--mobile');
    }

    container.append(this.googleMapContainer);

    var center = this.googleMap.getCenter();
    google.maps.event.trigger(this.googleMap, 'resize');
    this.googleMap.setCenter(center);
  };

  $.fn[pluginName] = function(options) {
    var method = false,
      methodArgs = arguments;

    if (typeof options == 'string') {
      method = options;
    }

    return this.each(function() {
      var plugin = $.data(this, namespace);

      if (!plugin && !method) {
        $.data(this, namespace, new Plugin(this, options));
      } else if (method) {
        callMethod(plugin, method, Array.prototype.slice.call(methodArgs, 1));
      }
    });
  };
}(jQuery));

/**
 * Plugin to handle the header search
 */

// moving to SS
// (function ($) {

//   'use strict';

//   var pluginName = 'trademarkHeaderSearch',
//     namespace = 'plugin_' + pluginName;

//   /**
//    * The Plugin constructor
//    */
//   function Plugin(element) {
//     this.headerSearch = $(element);
//     this.headerSearchForm = this.headerSearch.find('.header-search__form');
//     this.headerInput = this.headerSearch.find('.header-search__input');
//     this.headerSearchResults = this.headerSearch.find('.header-search__results-wrapper');

//     this.searchResultsTemplate = Template7.compile($('#search-results-template').html());
//     this.searchMode = "product",
//     this.body = $('body');
//     this.pageOverlay = $('.page__overlay');

//     this.sidebarNavInstance = $('.sidebar-nav').data('plugin_trademarkMobileSidebar');
//     this.miniCartInstance = $('.js-mini-cart').data('plugin_trademarkMiniCart');

//     $('[data-action="open-search"]').on('click', $.proxy(this._openSearch, this));
//     $('[data-action="close-search"]').on('click', $.proxy(this._closeSearch, this));

//     this.headerInput.on('keyup', $.proxy(this._initSearch, this));

//     this.headerSearchForm.on('submit', $.proxy(this._formSubmitted, this));
//   }

//   Plugin.prototype.destroy = function() {
//     $('[data-action="open-search"]').off('click');
//     $('[data-action="close-search"]').off('click');

//     this.headerSearch.removeData('plugin_trademarkHeaderSearch');
//     this.headerInput.off('keyup');
//     this.headerSearchForm.off('submit');
//     this.body.off('.trademarkHeaderSearch');
//   };

//   Plugin.prototype._openSearch = function(event) {
//     var self = this;

//     // If either mobile sidebar or mini-cart are open we must first close them, otherwise we open directly

//     if (this.sidebarNavInstance.state === 'opening' || this.sidebarNavInstance.state === 'opened') {
//       this.sidebarNavInstance._toggleSidebar(event);

//       $(document).one('closed.trademarkMobileSidebar', function() {
//         self._doOpenSearch();
//       });
//     } else if (undefined !== this.miniCartInstance && (this.miniCartInstance.state === 'opening' || this.miniCartInstance.state === 'opened')) {
//       this.miniCartInstance._toggleMiniCart(event);

//       $(document).one('closed.trademarkMiniCart', function() {
//         self._doOpenSearch();
//       });
//     } else {
//       this._doOpenSearch(); // Both are closed so we can open directly
//     }

//     event.preventDefault();
//   };

//   Plugin.prototype._closeSearch = function(event) {
//     this.body.removeClass('no-scroll');
//     this.pageOverlay.removeClass('page__overlay--open');
//     this.headerSearch.removeClass('header-search--open');
//     this.body.off('.trademarkHeaderSearch');

//     event.preventDefault();
//   };

//   Plugin.prototype._doOpenSearch = function() {
//     var self = this;

//     this.body.addClass('no-scroll');
//     this.pageOverlay.addClass('page__overlay--open');

//     this.headerSearch.addClass('header-search--open');
//     this.headerSearch.one('transitionend', function() {
//       self._cursorFocus(self.headerInput);
//     });

//     this.body.on('keyup.trademarkHeaderSearch', function(event) {
//       if (event.keyCode == 27) {
//         self._closeSearch(event);
//       }
//     });

//     this.body.on('click.trademarkHeaderSearch', function(outsideEvent) {
//       if (!$(outsideEvent.target).closest('#shopify-section-header').length) {
//         self._closeSearch(outsideEvent);
//       }
//     });
//   };

//   Plugin.prototype._initSearch = function(event) {
//     var target = $(event.currentTarget);

//     clearTimeout(target.data('timeout'));

//     target.data('timeout', setTimeout($.proxy(this._doSearch, this), 250));
//   };

//   Plugin.prototype._doSearch = function(event) {
//     // No autocompletion on mobile
//     if (Modernizr.mq('(max-width: 559px)')) {
//       // return;
//     }

//     // If we are on mobile, we do a single search that will get all resources, based on the setting. If tablet and higher, we do two Ajax calls: one
//     // that will fetch product only, and another one that will fetch anything else
//     if (this.headerInput.val() === '') {
//       this.headerSearchResults.empty();
//       return; // No need to search if it's empty
//     } else {
//       this.headerSearchResults.html(this.searchResultsTemplate({is_loading: true}));
//     }

//     if (this.searchMode === 'product') {
//       this._doCompleteSearch();
//     } else {
//       this._doSeparateSearch();
//     }
//   };

//   Plugin.prototype._doCompleteSearch = function(event) {
//     var self = this;
//     // var search_word = this.headerInput.val().replace(/[`~!@#$%^&*()_|+\%=?;:'",.<>\{\}\[\]\\\/]/gi,'');
//     var special_character = /[`!@#$%^&()_+\=\[\]{};':"\\|,.<>\/?~]/;
//     $.ajax({
//       method: 'GET',
//       url: window.theme.localeRootUrl+this.headerInput.val() == null || this.headerInput.val()=='' || special_character.test(this.headerInput.val()) ? '/search?view=json&q=""' : '/search?view=json&q='+this.headerInput.val()+'*',
//       dataType: 'json',
//       data: {
//         type: this.searchMode
//       }
//     }).then(function(data) {
//       var onlyReview = false;
//       var underReviewC = 0;
//       var reviewerC = 0;
//       var dataR = data.results;
//       for(var i=0;i<dataR.length;i++){
//         if(dataR[i].underReview == true){
//           underReviewC = underReviewC + 1;
//         }
//         if(dataR[i].reviewer == true){
//           reviewerC = reviewerC + 1;
//         }

//       }
//       if(underReviewC == dataR.length){
//         if(reviewerC != dataR.length){
//           onlyReview = true
//         }

//       }
//       if(onlyReview){
//         self.headerSearchResults.html(self.searchResultsTemplate({
//           is_loading: false,
//           split_search: false,
//           on_sale_label: window.languages.productLabelsOnSale,
//           results: data['results'],
//           has_results: 0,
//           results_count: 0,
//           results_label: "Your search did not return any results.",
//           results_url: (data['url'] + '&type=' + self.searchMode)
//         }));
//       }
//       else{
//         self.headerSearchResults.html(self.searchResultsTemplate({
//         is_loading: false,
//         split_search: false,
//         on_sale_label: window.languages.productLabelsOnSale,
//         results: data['results'],
//         has_results: (data['results'].length > 0),
//         results_count: data['results_count'],
//         results_label: data['results_label'],
//         results_url: (data['url'] + '&type=' + self.searchMode)
//       }));
//       }
//     });
//   };

//   Plugin.prototype._doSeparateSearch = function(event) {
//     var searchTypes = this.searchMode.split(','),
//       self = this;

//     var firstSearch = $.ajax({
//       method: 'GET',
//       url: window.theme.localeRootUrl + '/search?view=json',
//       dataType: 'json',
//       data: {
//         q: this.headerInput.val() + '*',
//         type: searchTypes[0]
//       }
//     });

//     var lastSearch = $.ajax({
//       method: 'GET',
//       url: window.theme.localeRootUrl + '/search?view=json',
//       dataType: 'json',
//       data: {
//         q: this.headerInput.val() + '*',
//         type: searchTypes.slice(1).join(',')
//       }
//     });

//     $.when(firstSearch, lastSearch).then(function(data1, data2) {
//       self.headerSearchResults.html(self.searchResultsTemplate({
//         is_loading: false,
//         split_search: true,
//         on_sale_label: window.languages.productLabelsOnSale,
//         has_products_results: (data1[0]['results'].length > 0),
//         has_others_results: (data2[0]['results'].length > 0),
//         products: {
//           results: data1[0]['results'],
//           results_count: data1[0]['results_count'],
//           results_label: data1[0]['results_label'],
//           results_url: (data1[0]['url'] + '&type=' + searchTypes[0])
//         },
//         others: {
//           results: data2[0]['results'],
//           results_count: data2[0]['results_count'],
//           results_label: data2[0]['results_label'],
//           results_url: (data2[0]['url'] + '&type=' + searchTypes.slice(1).join(','))
//         }
//       }));
//     });
//   };

//   Plugin.prototype._formSubmitted = function(event) {
//     var special_characters = /[`!@#$%^&()_+\=\[\]{};':"\\|,.<>\/?~]/;
//     this.headerInput.val() == null || this.headerInput.val()=='' || special_characters.test(this.headerInput.val()) ? this.headerInput.val('') : this.headerInput.val(this.headerInput.val() + '*');
//     return true;
//   };

//   /**
//    * Allow to give focus on an item while preserving scroll position
//    */
//   Plugin.prototype._cursorFocus = function(element) {
//     var x = window.scrollX,
//       y = window.scrollY;

//     element.focus();
//     window.scrollTo(x, y);
//   };

//   $.fn[pluginName] = function(options) {
//     var method = false,
//       methodArgs = arguments;

//     if (typeof options == 'string') {
//       method = options;
//     }

//     return this.each(function() {
//       var plugin = $.data(this, namespace);

//       if (!plugin && !method) {
//         $.data(this, namespace, new Plugin(this, options));
//       } else if (method) {
//         callMethod(plugin, method, Array.prototype.slice.call(methodArgs, 1));
//       }
//     });
//   };
// }(jQuery));
/**
 * Plugin to handle home slideshow
 */

(function ($) {

  'use strict';

  var pluginName = 'trademarkHomeSlideshow',
    namespace = 'plugin_' + pluginName;

  /**
   * The Plugin constructor
   * @constructor
   * @param {HTMLElement} element The element that will be monitored
   */
  function Plugin(element) {
    this.slideshow = $(element);
    this.slideshowAnchor = this.slideshow.find('.slideshow--anchor');
    this.slideshowAnchorSlides = this.slideshowAnchor.find('.slideshow__slide');
    this.slideshowMain = this.slideshow.find('.slideshow--main');
    this.slideshowMainSlides = this.slideshowMain.find('.slideshow__slide');
    this.slideshowSlidesCount = this.slideshowMainSlides.length;
    this.slideshowCount = this.slideshow.find('.slideshow__current-slide');
    this.slideshowButtons = this.slideshow.find('.slideshow__nav-button');
    this.hasTransitionPending = false;
    this.paused = false;

    this.slideshow.find('.slideshow__nav-next').on('click', $.proxy(this.nextSlide, this));
    this.slideshow.find('.slideshow__nav-prev').on('click', $.proxy(this.prevSlide, this));
    this.slideshow.on('swipeleft', $.proxy(this.nextSlide, this));
    this.slideshow.on('swiperight', $.proxy(this.prevSlide, this));

    // If we have the autoplay set up, we activate it
    this.hasAutoplay = (this.slideshow.attr('data-autoplay') === 'true');
    this.autoplayCycleSpeed = parseInt(this.slideshow.attr('data-cycle-speed'));

    if (this.hasAutoplay) {
      this._setupAutoplay();
    }

    // We simulate an initial change so that various events can be hooked up correctly
    var firstSlide = this.slideshowMainSlides.eq(0);
    this._didChange(firstSlide, firstSlide);
  }

  /**
   * Clear the memory and remove any listener
   */
  Plugin.prototype.destroy = function() {
    this.slideshow.off('swipeleft swiperight');
    this.slideshowButtons.off('click');
    clearInterval(this.timer);

    this.slideshow.removeData('plugin_trademarkHomeSlideshow');
  };

  /**
   * Move to the next slide
   */
  Plugin.prototype.nextSlide = function() {
    var currentAnchorSlide = this.slideshowAnchorSlides.filter('.slideshow__slide--active'),
      prevOrNextAnchorSlide = currentAnchorSlide.next('.slideshow__slide'),
      currentMainSlide = this.slideshowMainSlides.filter('.slideshow__slide--active'),
      prevOrNextMainSlide = currentMainSlide.next('.slideshow__slide');

    if (prevOrNextAnchorSlide.length === 0) {
      prevOrNextAnchorSlide = this.slideshowAnchorSlides.first();
    }

    if (prevOrNextMainSlide.length === 0) {
      prevOrNextMainSlide = (prevOrNextMainSlide.length !== 0) ? prevOrNextMainSlide : this.slideshowMainSlides.first();
    }

    this._move(currentAnchorSlide, prevOrNextAnchorSlide, currentMainSlide, prevOrNextMainSlide, 'next');

    return false;
  };

  /**
   * Move to the previous slide
   */
  Plugin.prototype.prevSlide = function() {
    var currentAnchorSlide = this.slideshowAnchorSlides.filter('.slideshow__slide--active'),
      prevOrNextAnchorSlide = currentAnchorSlide.prev('.slideshow__slide'),
      currentMainSlide = this.slideshowMainSlides.filter('.slideshow__slide--active'),
      prevOrNextMainSlide = currentMainSlide.prev('.slideshow__slide');

    if (prevOrNextAnchorSlide.length === 0) {
      prevOrNextAnchorSlide = this.slideshowAnchorSlides.last();
    }

    if (prevOrNextMainSlide.length === 0) {
      prevOrNextMainSlide = (prevOrNextMainSlide.length !== 0) ? prevOrNextMainSlide : this.slideshowMainSlides.last();
    }

    this._move(currentAnchorSlide, prevOrNextAnchorSlide, currentMainSlide, prevOrNextMainSlide, 'previous');

    return false;
  };

  /**
   * Move to a specific slide
   */
  Plugin.prototype.goToSlide = function(index) {
    var desiredIndex = parseInt(index) - 1,
      currentAnchorSlide = this.slideshowAnchorSlides.filter('.slideshow__slide--active'),
      prevOrNextAnchorSlide = this.slideshowAnchorSlides.eq(desiredIndex === 0 ? 1 : (desiredIndex + 1) % this.slideshowSlidesCount),
      currentMainSlide = this.slideshowMainSlides.filter('.slideshow__slide--active'),
      prevOrNextMainSlide = this.slideshowMainSlides.eq(desiredIndex),
      currentIndex = this.slideshowMainSlides.index(currentMainSlide);

    if (currentIndex === desiredIndex) {
      return;
    }

    this._move(currentAnchorSlide, prevOrNextAnchorSlide, currentMainSlide, prevOrNextMainSlide, (currentIndex > desiredIndex) ? 'previous' : 'next');

    return false;
  };

  /**
   * Pause the autoplay
   */
  Plugin.prototype.pause = function() {
    this.paused = true;
  };

  /**
   * Restart the autoplay
   */
  Plugin.prototype.play = function() {
    this.paused = false;
  };

  /**
   * Add the various classes to properly animate all the slides
   *
   * @param currentAnchorSlide
   * @param prevOrNextAnchorSlide
   * @param currentMainSlide
   * @param prevOrNextMainSlide
   * @param direction
   * @private
   */
  Plugin.prototype._move = function(currentAnchorSlide, prevOrNextAnchorSlide, currentMainSlide, prevOrNextMainSlide, direction) {
    if (this.hasTransitionPending) {
      return;
    }

    if (this.hasAutoplay && !this.paused) {
      this._clearAutoplay();
    }

    var self = this;

    this.slideshowButtons.attr('disabled', 'disabled');

    this._willChange(currentMainSlide, prevOrNextMainSlide);

    if (Modernizr.cssanimations) {
      var animationClasses = 'slideshow__slide--animating ' + (direction === 'next' ? 'slideshow__slide--animating-rtl' : 'slideshow__slide--animating-ltr');

      // 1st: add all the classes needed to trigger animations
      prevOrNextAnchorSlide.addClass(animationClasses);
      prevOrNextMainSlide.addClass(animationClasses);
      currentMainSlide.addClass('slideshow__slide--removing');
      currentAnchorSlide.addClass('slideshow__slide--removing');

      // 2nd: listen to the event to properly removing the classes when animations are over
      prevOrNextAnchorSlide.find('.slideshow__media-container').one('webkitAnimationEnd animationend', function() {
        prevOrNextAnchorSlide.removeClass(animationClasses).addClass('slideshow__slide--active');
        currentAnchorSlide.removeClass('slideshow__slide--active slideshow__slide--removing');
      });

      prevOrNextMainSlide.find('.slideshow__media').one('webkitAnimationEnd animationend', function() {
        prevOrNextMainSlide.removeClass(animationClasses).addClass('slideshow__slide--active');
        currentMainSlide.removeClass('slideshow__slide--active slideshow__slide--removing');

        self.slideshowCount.text(prevOrNextMainSlide.attr('data-slide-index'));
        self.slideshowButtons.removeAttr('disabled');

        self._didChange(currentMainSlide, prevOrNextMainSlide);
      });
    } else {
      prevOrNextAnchorSlide.addClass('slideshow__slide--active');
      currentAnchorSlide.removeClass('slideshow__slide--active');

      prevOrNextMainSlide.addClass('slideshow__slide--active');
      currentMainSlide.removeClass('slideshow__slide--active');

      this.slideshowCount.text(prevOrNextMainSlide.attr('data-slide-index'));
      this.slideshowButtons.removeAttr('disabled');

      this._didChange(currentMainSlide, prevOrNextMainSlide);
    }
  };

  /**
   * Callback that is called before the slide changes
   */
  Plugin.prototype._willChange = function(previousSlide, newSlide) {
    this.hasTransitionPending = true;
  };

  /**
   * Callback that is called after the slide has changed
   */
  Plugin.prototype._didChange = function(previousSlide, newSlide) {
    this.hasTransitionPending = false;

    if (this.hasAutoplay && !this.paused) {
      this._setupAutoplay();
    }
  };

  /**
   * Setup the autoplay which allows to automatically change slide
   */
  Plugin.prototype._setupAutoplay = function() {
    var self = this;

    // If there is a previous timer, clear it
    this._clearAutoplay();

    this.timer = setInterval(function() {
      if (!self.paused) {
        self.nextSlide();
      }
    }, this.autoplayCycleSpeed);
  };

  /**
   * Clear the autoplay
   */
  Plugin.prototype._clearAutoplay = function() {
    if (this.timer) {
      clearInterval(this.timer);
    }

    this.timer = null;
  };

  $.fn[pluginName] = function(options) {
    var method = false,
      methodArgs = arguments;

    if (typeof options == 'string') {
      method = options;
    }

    return this.each(function() {
      var plugin = $.data(this, namespace);

      if (!plugin && !method) {
        $.data(this, namespace, new Plugin(this, options));
      } else if (method) {
        callMethod(plugin, method, Array.prototype.slice.call(methodArgs, 1));
      }
    });
  };
}(jQuery));
/**
 * Plugin to handle the main nav
 */

(function ($) {

  'use strict';

  var pluginName = 'trademarkMainNav',
    namespace = 'plugin_' + pluginName;

  /**
   * The Plugin constructor
   */
  function Plugin(element) {
    this.mainNav = $(element);
    this.mainNavLinks = this.mainNav.find('.header__link');

    // Improve accessibility of menu by adding classes when an item is on focus
    this.mainNavLinks.on('focusin', function() {
      $(this).addClass('header__link--focused');
    });

    this.mainNavLinks.on('focusout', function() {
      $(this).removeClass('header__link--focused');
    });

    // Add a listener to check if the main nav can fit and init it (only when the logo is positioned in the center)
    if (!this.mainNav.hasClass('header__main-nav--stretched')) {
      this.mainNavWidth = Math.ceil(this.mainNav.width() + 35);
      this._verifyOverlap();

      $(window).on('resize.trademarkMainNav', $.proxy(this._verifyOverlap, this));
    }

    // We need to handle the overlap
    this.mainNav.find('.nav-dropdown--first').on('mouseenter', function() {
      var windowWidth = window.innerWidth,
        item = $(this),
        nestedMenus = item.find('.nav-dropdown--second'),
        rightEdge = this.getBoundingClientRect().right,
        shouldOpenLeft = false;

      nestedMenus.each(function(index, item) {
        if ((rightEdge + item.offsetWidth) > windowWidth) {
          shouldOpenLeft = true;
          return false; // this allows to break from the each
        }
      });

      if (shouldOpenLeft) {
        nestedMenus.addClass('nav-dropdown--left');
      } else {
        nestedMenus.removeClass('nav-dropdown--left');
      }
    });
  }

  Plugin.prototype.destroy = function() {
    this.mainNavLinks.off('focusin focusout');
    this.mainNav.removeData('plugin_trademarkMainNav');

    $(window).off('.trademarkMainNav');
  };

  Plugin.prototype._verifyOverlap = function() {
    // We need to find if the main nav overlap the logo. To find out this, we get the right edge of the main nav, and verify it's not "after" the left
    // position of the logo (the +35 is to add a bit more space)
    var isOverlapping = this.mainNavWidth > Math.ceil($('.header__logo').position().left - $('.header__inner').position().left);

    // If it's overlapping, we use the mobile navigation instead
    if (isOverlapping) {
      this.mainNav.hide();
      $('.header__nav-toggle').removeClass('hidden-desk');
    } else {
      this.mainNav.show();
      $('.header__nav-toggle').addClass('hidden-desk');
    }

    $('.header').addClass('header--init');
  };

  $.fn[pluginName] = function(options) {
    var method = false,
      methodArgs = arguments;

    if (typeof options == 'string') {
      method = options;
    }

    return this.each(function() {
      var plugin = $.data(this, namespace);

      if (!plugin && !method) {
        $.data(this, namespace, new Plugin(this, options));
      } else if (method) {
        callMethod(plugin, method, Array.prototype.slice.call(methodArgs, 1));
      }
    });
  };
}(jQuery));
/**
 * Plugin to handle the mini-cart
 */

(function ($) {

  'use strict';

  var pluginName = 'trademarkMiniCart',
    namespace = 'plugin_' + pluginName;

  /**
   * The Plugin constructor
   */
  function Plugin(element) {
    this.miniCart = $(element);
    this.announcementBar = $('.announcement-bar');
    this.header = $('.header');
    this.headerCartCount = $('.header__cart-count');
    this.sidebarNav = $('.sidebar-nav');

    this.state = 'closed';

    this.body = $('body');
    this.pageOverlay = $('.page__overlay');

    this.body.on('click.trademarkMiniCartToggle keypress.trademarkMiniCartToggle', '[data-action="toggle-mini-cart"]', $.proxy(this._toggleMiniCart, this));
    this.miniCart.on('click', '[data-action="remove-line-item"]', $.proxy(this._removeLine, this));

    $(document).on('theme:cart:updated', $.proxy(this._cartUpdated, this));

    // We automatically re-render it a first time to solve a strange issue where adding a product in Ajax, going to Checkout and go back does not re-render
    // the very last version in Liquid
    this._rerender();

    if (Modernizr.csstransitions) {
      this.miniCart.on('transitionend', $.proxy(this._emitTransitionEvent, this));
    }
  }

  Plugin.prototype.destroy = function() {
    this.miniCart.removeData('plugin_trademarkMiniCart');
    this.miniCart.find('[data-action="remove-line-item"]').off('click');
    this.body.off('.trademarkMiniCart');
    this.body.off('.trademarkMiniCartToggle');
    this.body.removeClass('mini-cart-open');

    $(document).off('theme:cart:updated');
    $(window).off('.trademarkMiniCart');
  };

  Plugin.prototype.getState = function() {
    return this.state;
  };

  Plugin.prototype._toggleMiniCart = function(event) {
    var self = this;

    // The mini-cart can be toggled using "Enter" key in keyboard as well
    if ((event.keyCode ? event.keyCode : event.which) == 13) {
      event.preventDefault(); // Prevent to follow the link
    }

    this.miniCart.toggleClass('mini-cart--open js-mini-cart-open');

    if (this.miniCart.hasClass('js-mini-cart-open')) {
      this.body.addClass('mini-cart-open');
      $('.shopify-section__header').css('z-index', '');

      setTimeout(() => {
        $('.js-mini-cart-items').removeClass('no-visibility');
      }, 500);

      // Before opening, we must check if the nav sidebar is open. If that's the case we first close it
      var sidebarNavInstance = this.sidebarNav.data('plugin_trademarkMobileSidebar');

      if (sidebarNavInstance.state === 'opening' || sidebarNavInstance.state === 'opened') {
        sidebarNavInstance._toggleSidebar(event);
      }

      this.state = 'opening';
      $(document).trigger('opening.trademarkMiniCart');

      // A pending re-render means the drawer still holds the previous cart, so
      // the mask cannot wait before covering it
      this._showLoader(this.rerendering);

      // The overflow lock detaches the scrollport and unpins the sticky global
      // bars, so src/js/lib/mini-cart.js holds the page still instead.
      this.pageOverlay.addClass('page__overlay--open');

      if (!Modernizr.csstransitions) {
        this.state = 'opened';
        $(document).trigger('opened.trademarkMiniCart');
      }

      this.miniCart.one('transitionend', function() {
        self.miniCart.focus();  // Allows to give focus for better accessibility on keyboard

        // A re-render still in flight swaps the whole inner out, so the mask has
        // to stay until the fresh markup lands
        if (!self.rerendering) {
          self._hideLoader();
        }
      });

      this.body.on('keyup.trademarkMiniCart', function(outsideEvent) {
        if (outsideEvent.keyCode == 27) {
          self._toggleMiniCart(outsideEvent);
        }
      });

      this.body.on('click.trademarkMiniCart', function(outsideEvent) {
        if (!$(outsideEvent.target).closest('#shopify-section-header').length) {
          self._toggleMiniCart(outsideEvent);
        }
      });

      if (SDG?.Data?.currencyCode === 'HUF') {
        setTimeout(() => {
          const $hufPriceElements = document.querySelectorAll('[data-huf-price]');
          if ($hufPriceElements.length) {
            $hufPriceElements.forEach((element) => {
              const hufPrice = element.getAttribute('data-huf-price');
              const tlsPrice = (hufPrice / 100).toLocaleString('hu-hu', {
                maximumFractionDigits: 2,
                minimumFractionDigits: 2,
              });
              const formattedPrice = tlsPrice.replace(/\s/g, '.');
              element.innerHTML = `Ft${formattedPrice}`;
            });
          }
        }, 350);
      }
    } else {
      this.state = 'closing';
      $(document).trigger('closing.trademarkMiniCart');

      this.body.removeClass('no-scroll');
      this.body.removeClass('mini-cart-open');
      this.body.off('.trademarkMiniCart');
      this.pageOverlay.removeClass('page__overlay--open');
      $('.shopify-section__header').css('z-index', '');

      if (!Modernizr.csstransitions) {
        this.state = 'closed';
        $(document).trigger('closed.trademarkMiniCart');
      }
    }

    event.preventDefault();
  };

  Plugin.prototype._cartUpdated = function(event, cart, forceOpening) {
    if (event.detail) {
      cart = event.detail.cart;
      forceOpening = event.detail.forceOpening;
    }
    this.headerCartCount.text(cart.item_count);
    if(cart.item_count > 0) {
      this.headerCartCount[0]?.classList.remove('hide');
      this.headerCartCount[1]?.classList.remove('hide');
    }

    // We only re-render the cart from server. Since automatic discount can alter the lines as well as the total,
    // it is easier to simply re-render from the source
    this._rerender();

    if (forceOpening) {
      this._toggleMiniCart(event);
    }

    const updateMiniCartHeader = (itemCount) => {
      const {
        item: tItem,
        items: tItems,
        added: tAdded,
      } = SDG?.Data?.miniCartTranslations
      const miniCartHeaderText = `${itemCount} ${itemCount > 1 ? tItems.toUpperCase() : tItem.toUpperCase()} ${tAdded.toUpperCase()}`;
      setTimeout(() => {
        $('.js-mini-cart-header.display-sm').text(miniCartHeaderText);
        SDG.Data.gwpIncluded = false;
      }, 600);
    };

    if (event?.detail?.atcClicked === 'recommender') {
      updateMiniCartHeader(1);
    } else if (SDG.Data.itemsAddedToCart && SDG.Data.itemsAddedToCart.length) {
      updateMiniCartHeader(SDG.Data.itemsAddedToCart.length);
    } else if (SDG.Data.itemsAddedToCartQty) {
      updateMiniCartHeader(SDG.Data.itemsAddedToCartQty);
      SDG.Data.itemsAddedToCartQty = null;
    } else if (SDG.Data.exclusivePdpChecked && SDG.Data.exclusivePdpChecked > 1) {
      updateMiniCartHeader(SDG.Data.exclusivePdpChecked);
    } else if (SDG.Data.gwpIncluded) {
      updateMiniCartHeader(SDG.Data.gwpIncluded);
    } else {
      const qtyInput = document.querySelector('.js-qty-input');
      if (qtyInput) {
        updateMiniCartHeader(parseInt(qtyInput.value, 10));
      }
    }
  };

  Plugin.prototype._removeLine = function(event) {
    var target = $(event.currentTarget),
      variantId = target.attr('data-variant-id'),
      lineItem = target.closest('.js-mini-cart-item-wrapper'),
      items = target.closest('.js-mini-cart-items');

    items.addClass('mini-cart__items--loading');

    $.ajax({
      method: 'POST',
      url: Shopify.routes.root + 'cart/change.js',
      dataType: 'json',
      data: {
        quantity: 0,
        id: variantId
      }
    }).then(function(newCart) {
      items.removeClass('mini-cart__items--loading');
      lineItem.slideUp(250, function() {$(this).remove();});

      $(document).trigger('theme:cart:updated', [newCart, false, false]);
    });

    event.preventDefault();
  };

  Plugin.prototype._showLoader = function(instant) {
    var self = this;

    window.clearTimeout(this.loaderClearTimeout);
    window.clearTimeout(this.loaderFailsafe);

    if (!this._onRerendered) {
      this._onRerendered = function() {
        self._hideLoader();
      };
    }

    this.miniCart.addClass('mini-cart--loading');
    this.miniCart.toggleClass('mini-cart--loading-instant', Boolean(instant));
    $('.js-mini-cart-loader').html('<div class="mini-cart__loader-icon"></div>');

    document.addEventListener('mini-cart:opened', this._onRerendered, { once: true });

    // The re-render can fail or never run, and the mask must not outlive it
    this.loaderFailsafe = window.setTimeout(function() {
      self._hideLoader();
    }, 4000);
  };

  Plugin.prototype._hideLoader = function() {
    window.clearTimeout(this.loaderFailsafe);

    if (this._onRerendered) {
      document.removeEventListener('mini-cart:opened', this._onRerendered);
    }

    this.miniCart.removeClass('mini-cart--loading mini-cart--loading-instant');

    // Keep the spinner in place while the mask fades out
    this.loaderClearTimeout = window.setTimeout(function() {
      $('.js-mini-cart-loader').html('');
    }, 200);
  };

  /**
   * Rerender each items of the mini cart
   *
   * @param cart
   * @private
   */
  Plugin.prototype._rerender = function() {
    // We render the alternate mini-cart template instead of rendering it in JavaScript. This allows app vendor to hook their own logic within the
    // mini-cart in pure Liquid
    var self = this;
   var baseURL = Shopify.routes.root;
    // console.log(baseURL);
    //   if(baseURL == "/"){
    //     baseURL = window.theme.localeRootUrl;
    //   }

    this.rerendering = true;

    $.ajax(baseURL + 'cart?view=mini-cart').always(function() {
      self.rerendering = false;
    }).then(function(result) {
      var domResult = $(result),
        miniCartCount = domResult.attr('data-cart-item-count');

      self.miniCart.find('.js-mini-cart-inner').replaceWith(domResult.find('.js-mini-cart-inner'));
      self.headerCartCount.text(miniCartCount);

      var cartOpenEvent = new Event('mini-cart:opened');
      document.dispatchEvent(cartOpenEvent);

      self._showAddedProductsMiniCart();
    });
  };

  Plugin.prototype._showAddedProductsMiniCart = function() {
    var checkIfGwpSelected = document.querySelector('.js-product-gwp-input:checked');
    var addOnCheckedOnly = document.querySelectorAll('.js-product-add-on-input:checked').length;
    var addOnChecked = document.querySelectorAll('.js-product-add-on-input:checked,.upsell-products');
    const { gwp } = SDG.Data;

    if (SDG.Data.miniCartAlert) {
      var $alert = this.miniCart.find('.js-mini-cart-alert');
      var $alertMessage = $alert.find('.js-mini-cart-alert-message');
      if ($alert.length && $alertMessage.length) {
        $alertMessage.text(SDG.Data.miniCartAlert);
        $alert.removeClass('hide').removeAttr('hidden');
      }
      SDG.Data.miniCartAlert = null;
    }

    if (gwp && gwp.type === 'spend_x_get_y') {
      if ($('.js-mini-cart-item-wrapper').first().attr('data-sxgy-eligible')) {
        $('.js-cart-gwp-progress').first().removeClass('hide');
      }
    }

    if (SDG.Data.itemsAddedToCart && Array.isArray(SDG.Data.itemsAddedToCart) && SDG.Data.itemsAddedToCart.length > 0) {
      SDG.Data.itemsAddedToCart.forEach(function(item) {
        var id = item.id != null ? item.id : item.variant_id;
        if (id == null) return;
        var idStr = String(id);
        var $el = $(`.js-mini-cart-item-wrapper[data-variant-id="${idStr}"]`);
        if (!$el.length) {
          $el = $(`.js-mini-cart-item-wrapper[data-variant-id="${id}"]`);
        }
        $el.removeClass('hide');
      });
      SDG.Data.itemsAddedToCart = null;
      return;
    }

    if (addOnChecked && addOnCheckedOnly) {
      $('.js-mini-cart-item-wrapper').each((index, el) => {
        if (index <= addOnChecked.length) {
          __.removeClass(el, 'hide');
        }
      })
    } else if (checkIfGwpSelected) {
      $('.js-mini-cart-item-wrapper').each((index, el) => {
        if (index === 0 || el.dataset.gwpItem === 'true') {
          __.removeClass(el, 'hide');
        }
      })
    } else if (SDG.Data.is_exclusive_pdp) {
      if (SDG.Data.itemsAddedToCart) {
        SDG.Data.itemsAddedToCart.forEach(function(item) {
          $(`.js-mini-cart-item-wrapper[data-variant-id="${item.id}"]`).removeClass('hide');
        });
        SDG.Data.itemsAddedToCart = null;
        return;
      }
      // Get all checked upsell product inputs
      var checkedUpsells = $('input.upsell-products:checked').map(function() {
        return $(this).attr('id');
      }).toArray();

      if (checkedUpsells.length === 0) {
        checkedUpsells = [$('.js-memberships-select').val()];
      }

      // Filter out undefined/null values
      checkedUpsells = checkedUpsells.filter(Boolean);

      // Show mini cart items that match checked upsell variant IDs
      if ($('.js-mini-cart-item-wrapper').first().attr('data-added-from-rec')) {
        $('.js-mini-cart-item-wrapper').first().removeClass('hide');
      } else if (checkedUpsells && checkedUpsells.length > 0) {
        checkedUpsells.forEach(function(variantId) {
          $(`.js-mini-cart-item-wrapper[data-variant-id="${variantId}"]`).removeClass('hide');

          // only reveal first item in cart for multi membership sized products
          if ($('.js-memberships-select').length) {
            $('.js-mini-cart-item-wrapper').first().removeClass('hide');
          }
        });
      } else {
        $('.js-mini-cart-item-wrapper').first().removeClass('hide');
      }
    } else if ($('#combinedListing').length) {
      if (SDG.Data.itemsAddedToCart && Array.isArray(SDG.Data.itemsAddedToCart) && SDG.Data.itemsAddedToCart.length > 0) {
        SDG.Data.itemsAddedToCart.forEach(function(item) {
          $(`.js-mini-cart-item-wrapper[data-variant-id="${item.id}"]`).removeClass('hide');
        });
        SDG.Data.itemsAddedToCart = null;
      } else {
        $('.js-mini-cart-item-wrapper').first().removeClass('hide');
      }
    } else if (SDG.Data.itemsAddedToCart && Array.isArray(SDG.Data.itemsAddedToCart)) {
      SDG.Data.itemsAddedToCart.forEach(function(item) {
        var id = item.id != null ? item.id : item.variant_id;
        if (id == null) return;
        var idStr = String(id);
        var $el = $(`.js-mini-cart-item-wrapper[data-variant-id="${idStr}"]`);
        if (!$el.length) {
          $el = $(`.js-mini-cart-item-wrapper[data-variant-id="${id}"]`);
        }
        $el.removeClass('hide');
      });
      SDG.Data.itemsAddedToCart = null;
    } else {
      $('.js-mini-cart-item-wrapper').first().removeClass('hide');
    }

  }

  /**
   * Callback called whenever the transition (animation of opening or closing) is ended so we can emit events for other parts of the system
   */
  Plugin.prototype._emitTransitionEvent = function(event) {
    // The mobile drawer reveals itself with max-height instead of a transform
    if (event.originalEvent.propertyName !== 'transform' && event.originalEvent.propertyName !== 'max-height') {
      return;
    }

    if (this.state === 'opening' || this.state === 'opened') {
      this.state = 'opened';
      $(document).trigger('opened.trademarkMiniCart');
    } else {
      this.state = 'closed';
      $(document).trigger('closed.trademarkMiniCart');
    }
  };

  $.fn[pluginName] = function(options) {
    var method = false,
      methodArgs = arguments;

    if (typeof options == 'string') {
      method = options;
    }

    return this.each(function() {
      var plugin = $.data(this, namespace);

      if (!plugin && !method) {
        $.data(this, namespace, new Plugin(this, options));
      } else if (method) {
        callMethod(plugin, method, Array.prototype.slice.call(methodArgs, 1));
      }
    });
  };
}(jQuery));
/**
 * Plugin to handle the mobile sidebar
 */

(function ($) {

  'use strict';

  var pluginName = 'trademarkMobileSidebar',
    namespace = 'plugin_' + pluginName;

  /**
   * The Plugin constructor
   */
  function Plugin(element) {
    this.sidebarNav = $(element);
    this.announcementBar = $('.announcement-bar');
    this.header = $('.header');
    this.headerNavToggle = this.header.find('[data-action="toggle-mobile-sidebar"]');
    this.miniCart = $('.js-mini-cart');
    this.marketsBanner = $('#shopify-section-markets-banner');
    this.secondaryNav = $('.js-secondary-nav-container');

    this.state = 'closed';

    this.body = $('body');
    this.pageOverlay = $('.page__overlay');

    this.headerNavToggle.on('click.trademarkMobileSidebar', $.proxy(this._toggleSidebar, this));
    this.sidebarNav.find('[data-action="toggle-mobile-sub-menu"]').on('click.trademarkMobileSidebar', $.proxy(this._toggleSubMenu, this));

    $(window).on('resize.trademarkMobileSidebar', $.proxy(this._computeSidebarHeight, this));

    if (Modernizr.csstransitions) {
      this.sidebarNav.on('transitionend', $.proxy(this._emitTransitionEvent, this));
    }
  }

  Plugin.prototype.destroy = function() {
    this.header.find('[data-action="toggle-mobile-sidebar"]').off('click');
    this.sidebarNav.find('[data-action="toggle-mobile-sub-menu"]').off('click');
    this.body.off('.trademarkMobileSidebar');
    $(window).off('.trademarkMobileSidebar');

    this.sidebarNav.removeData('plugin_trademarkMobileSidebar');
  };

  Plugin.prototype.getState = function() {
    return this.state;
  };

  /**
   * Tgogle the navigation sidebar
   */
  Plugin.prototype._toggleSidebar = function(event) {
    if (document.querySelector('.us-interstitial-modal.is-visible')) return;
    var self = this;

    this.headerNavToggle.toggleClass('header__nav-toggle--open');
    this.sidebarNav.toggleClass('sidebar-nav--open');
    this._computeSidebarHeight();

    if (this.sidebarNav.hasClass('sidebar-nav--open')) {
      // Before opening, we must check if the mini-cart is open. If that's the case we first close it
      var miniCartInstance = this.miniCart.data('plugin_trademarkMiniCart');

      if (undefined !== miniCartInstance && (miniCartInstance.state === 'opening' || miniCartInstance.state === 'opened')) {
        miniCartInstance._toggleMiniCart(event);
      }

      this.state = 'opening';
      $(document).trigger('opening.trademarkMobileSidebar');
      this.body.addClass('mobile-nav-open');

      this.body.addClass('no-scroll');
      this.pageOverlay.addClass('page__overlay--open');

      this.body.on('click.trademarkMobileSidebar', function(outsideEvent) {
        if (!$(outsideEvent.target).closest('#shopify-section-header').length) {
          self._toggleSidebar(outsideEvent);
        }
      });

      if (!Modernizr.csstransitions) {
        this.state = 'opened';
        $(document).trigger('opened.trademarkMobileSidebar');
      }
    } else {
      this.state = 'closing';
      $(document).trigger('closing.trademarkMobileSidebar');

      this.header.css('height', this._getDefaultHeaderHeight());

      this.body.removeClass('mobile-nav-open');
      this.body.removeClass('no-scroll');
      this.body.off('.trademarkMobileSidebar');
      this.pageOverlay.removeClass('page__overlay--open');

      if (!Modernizr.csstransitions) {
        this.state = 'closed';
        $(document).trigger('closed.trademarkMobileSidebar');
      }
    }

    event.preventDefault();
  };

  /**
   * Toggle a submenu
   */
  Plugin.prototype._toggleSubMenu = function(event) {
    var buttonContainer = $(event.target),
      sidebarMenu = buttonContainer.closest('li').find('> .sidebar-nav__sub-links');

    buttonContainer.attr('aria-expanded', function(index, attr) {return attr === 'true' ? 'false' : 'true'})
      .find('.plus-button').toggleClass('plus-button--active');
    sidebarMenu.slideToggle();

    event.preventDefault();
  };

  /**
   * Secondary nav band height used to offset the mobile sidebar transform (theme.css -53px).
   */
  Plugin.prototype._getSecondaryNavOffset = function() {
    if (this._isDisplayed(this.secondaryNav)) {
      return this.secondaryNav.outerHeight();
    }

    return this.header.hasClass('header--no-secondary-nav') ? 1 : 0;
  };

  /**
   * Default mobile header height when resetting inline styles after closing the sidebar.
   */
  Plugin.prototype._getDefaultHeaderHeight = function() {
    return this.header.hasClass('header--no-secondary-nav') ? '48px' : '102px';
  };

  /**
   * Compute the correct sidebar height (by taking into account things such as top bar, viewport...)
   */
  Plugin.prototype._computeSidebarHeight = function() {
    const marketsBannerHeight = this.marketsBanner && this._isDisplayed(this.marketsBanner) ? this.marketsBanner.outerHeight() : 0;
    let announcementBarHeight = 0;

    var headerOuterHeight = this.header.outerHeight();

    if (this.announcementBar.length > 0) {
      announcementBarHeight = this.announcementBar.outerHeight();
    }

    const secondaryNavOffset = this._getSecondaryNavOffset();
    const sideBarHeight = window.innerHeight - headerOuterHeight - announcementBarHeight - marketsBannerHeight + secondaryNavOffset;
    this.sidebarNav.css('height', sideBarHeight + 'px');
  };

  Plugin.prototype._isDisplayed = function(element) {
    return !!(element && element.outerHeight() > 0);
  };

  /**
   * Callback called whenever the transition (animation of opening or closing) is ended so we can emit events for other parts of the system
   */
  Plugin.prototype._emitTransitionEvent = function(event) {
    if (event.originalEvent.propertyName !== 'transform') {
      return;
    }

    this._cursorFocus(this.sidebarNav); // Give the focus to the sidebar for easier keyboard navigation

    if (this.state === 'opening' || this.state === 'opened') {
      this.state = 'opened';
      $(document).trigger('opened.trademarkMobileSidebar');
    } else {
      this.state = 'closed';
      $(document).trigger('closed.trademarkMobileSidebar');
    }
  };

  /**
   * Allow to give focus on an item while preserving scroll position
   */
  Plugin.prototype._cursorFocus = function(element) {
    var x = window.scrollX,
      y = window.scrollY;

    element.focus();
    window.scrollTo(x, y);
  };

  $.fn[pluginName] = function(options) {
    var method = false,
      methodArgs = arguments;

    if (typeof options == 'string') {
      method = options;
    }

    return this.each(function() {
      var plugin = $.data(this, namespace);

      if (!plugin && !method) {
        $.data(this, namespace, new Plugin(this, options));
      } else if (method) {
        callMethod(plugin, method, Array.prototype.slice.call(methodArgs, 1));
      }
    });
  };
}(jQuery));
/**
 * Plugin to handle product update
 */

(function ($) {

  'use strict';

  var pluginName = 'trademarkProduct',
    namespace = 'plugin_' + pluginName;

  /**
   * The Plugin constructor
   * @constructor
   * @param {HTMLElement} element The element that will be monitored
   * @param {Object} options
   */
  function Plugin(element, options) {
    this.element = $(element);

    this._init(options);
  }

  Plugin.prototype._init = function(options) {
    this.product = options['product'];
    this.enableHistoryState = options['enableHistoryState'];
    this.optionsWithValues = options['optionsWithValues'];
    this.allowSelectingSoldOutVariants = options['allowSelectingSoldOutVariants'];
    this.context = options['context'] || null;
    this.singleOptionSelectors = this.element.find('.single-option-selector');
    this.combinedSelector = this.element.find('.js-option-selector');
    this.dataSelectors = this.element.find('[data-selector-type]').toArray();
    this.masterSelector = this.element.find('#product-select-' + options['product']['id']);
    this.productSlides = this.element.find('.product__slides');
    this.productPrices = this.element.find('.product__prices');
    this.addToCartButton = this.element.find('.product__add-to-cart');
    this.quantitySelector = this.element.find('.quantity-selector');

    this.currentVariant = this._getVariantFromOptions();

    this.singleOptionSelectors.on('change', $.proxy(this._onSelectorChanged, this));
    this.combinedSelector.on('change', $.proxy(this._onSelectorChanged, this));
    this.quantitySelector.find('[data-action="decrease-product-quantity"]').on('click', $.proxy(this._decreaseProductQuantity, this));
    this.quantitySelector.find('[data-action="increase-product-quantity"]').on('click', $.proxy(this._increaseProductQuantity, this));

    // Check if this is a multi-membership PDP and re-enable button if membership not in cart
    this._checkMultiMembershipButtonState();

    // Reflect the purchase limit on the CTAs as soon as the bag changes (FBT, mini-cart, etc.)
    this._syncPurchaseLimitState();
    this._onCartUpdatedSyncLimit = $.proxy(this._syncPurchaseLimitState, this);
    $(document).on('theme:cart:updated', this._onCartUpdatedSyncLimit);
    document.addEventListener('sdg:cart:updated', this._onCartUpdatedSyncLimit);

    const mappedVariantTitles = this.product.variants.map((variant) => variant.title).join(' - ');
    const strippedOptionWithValues = [...this.optionsWithValues];
    if (mappedVariantTitles.length > 1) {
      this.optionsWithValues.forEach((optionGroup, parentOptionIndex) => {
        const newOptionArray = [];
        optionGroup.values.forEach((option, childIndex) => {

          if (mappedVariantTitles.includes(option)) {
            newOptionArray.push(option);
          }

          if (childIndex === (optionGroup.values.length - 1)) {
            this.optionsWithValues[parentOptionIndex].values = newOptionArray;
          }
        });
      });
    }
    // In order to improve accessibility in keyboard, we allow to update swatches when pressing the Enter key over a label
    this.singleOptionSelectors.next('label').on('keypress', function(e) {
      if ((e.keyCode ? e.keyCode : e.which) == 13) {
        $(this).trigger('click');
      }
    });

    // If Ajax cart is enabled we add some more listeners to add product in the background
    $(document).on("click", ".upsell-container input[type='checkbox']", function () {
        const isJapanLocale = SDG.Data.locale === '/ja-jp' || SDG.Data.locale === '/en-jp';
        const currencyFormat = SDG.Data.toLocaleString;
        const localeStringParam = {
          maximumFractionDigits: 2,
          minimumFractionDigits: 2,
        };
        var mainProductprice = $("#product-price").val();
        var currTotal = parseFloat($(".bundle-total:first").text().replace(",","").replace(",","").replace(".","").replace(".", ""));
        var unitPrice = parseFloat($(this).data("price").toString().replace(",",''));

        var newTotal;
        if ($(this).is(':checked')){
          newTotal = currTotal + unitPrice;
          newTotal = newTotal / 100;

          $(".bundle-total").text(newTotal.toLocaleString(currencyFormat, localeStringParam));
          if(newTotal == 0){
            $(".product__prices").hide();
          }else{
            $(".product__prices").show();
          }
        } else {
          newTotal = currTotal - unitPrice;
          newTotal = newTotal / 100;

          $(".bundle-total").text(newTotal.toLocaleString(currencyFormat, localeStringParam));

          if(newTotal == 0 ){
            $(".product__prices").hide();
          }else{
            $(".product__prices").show();
          }
          $(".tnc-container").hide();
          $(".tnc-container").removeClass('showtnc');
        }

        if ($('input.digital-memb').is(':checked')){
          $(".tnc-container").show();
          $(".tnc-container").addClass('showtnc');
          $(".digital-memb").siblings("label").removeAttr("style");
        } else {
          $(this).removeAttr("checked");
          $(".pdp-sticky-atc").removeClass("atc-error-color").removeAttr("disabled");
          $("#add-to-cart-btn").removeClass("atc-error-color").removeAttr("disabled");
          $("#accept-terms-conditions").prop("checked", false);
        }
        if ($(".upsell-container input[type='checkbox']:checked").length <= 0){
          $(".pdp-sticky-atc").addClass("sold-out-btn").attr("disabled", "disabled");
          $("#add-to-cart-btn").addClass("sold-out-btn").attr("disabled", "disabled")
        } else {
          $(".pdp-sticky-atc").removeClass("sold-out-btn").removeAttr("disabled");
          $("#add-to-cart-btn").removeClass("sold-out-btn").removeAttr("disabled")
        }
    });

    $(document).on('change','#accept-terms-conditions', function () {
      const agreementChecked = $(this).is(':checked');
      if (agreementChecked) {
        $('.membership-agreement').hide();
      }
    });
     $(document).on("click",".product__add-to-cart", $.proxy(this._addToCart, this));
  };

  Plugin.prototype.destroy = function() {
    this.singleOptionSelectors.off('change');
    this.singleOptionSelectors.next('label').off('keypress');
    this.addToCartButton.off('click');
    this.quantitySelector.find('[data-action="decrease-product-quantity"]').off('click');
    this.quantitySelector.find('[data-action="increase-product-quantity"]').off('click');

    if (this._onCartUpdatedSyncLimit) {
      $(document).off('theme:cart:updated', this._onCartUpdatedSyncLimit);
      document.removeEventListener('sdg:cart:updated', this._onCartUpdatedSyncLimit);
    }

    this.element.removeData('plugin_trademarkProduct');
  };

  /**
   * ---------------------------------------------------------------------------------------------------
   * CODE THAT HANDLE PRODUCT OPERATIONS
   * ---------------------------------------------------------------------------------------------------
   */

  Plugin.prototype._decreaseProductQuantity = function(event) {
    var currentQuantity = this.quantitySelector.find('.quantity-selector__current-quantity'),
      currentQuantityAsNumber = parseInt(currentQuantity.text());

    // Do nothing if it's already one...
    if (currentQuantityAsNumber === 1) {
      event.preventDefault();
      return;
    }

    var newQuantity = currentQuantityAsNumber - 1;

    currentQuantity.text(newQuantity);

    this.element.find('[name="quantity"]').val(newQuantity);

    event.preventDefault();
  };

  Plugin.prototype._increaseProductQuantity = function(event) {
    var currentQuantity = this.quantitySelector.find('.quantity-selector__current-quantity'),
      currentQuantityAsNumber = parseInt(currentQuantity.text()),
      newQuantity = currentQuantityAsNumber + 1;

    currentQuantity.text(newQuantity);

    this.element.find('[name="quantity"]').val(newQuantity);

    event.preventDefault();
  };

  /**
   * ---------------------------------------------------------------------------------------------------
   * CODE THAT HANDLE VARIANT CHANGES IN THE FRONT
   * ---------------------------------------------------------------------------------------------------
   */

  /**
   * Whenever the variant changes, we have several things to update: the slideshow image, the prices,
   * the labels...
   */
  Plugin.prototype._onVariantChanged = function(previousVariant, newVariant) {
    if (!newVariant) return;

    const qtySelector = document.querySelector('.js-qty');
    if (window.SDG && window.SDG.updateQuantityOnVariantChange && qtySelector) window.SDG.updateQuantityOnVariantChange(newVariant.id);

    // 1st: the slideshow
    this._updateSlideshowImage(previousVariant, newVariant);

    // 2st: the prices
    this._updateProductPrices(previousVariant, newVariant);

    // 2st: the unit prices
    this._updateProductUnitPrices(previousVariant, newVariant);

    // 4rd: update the variant dropdowns
    this._updateSelectors(previousVariant, newVariant);

    // 5th: the add to cart button
    this._updateAddToCartButton(previousVariant, newVariant);
    $("#prodSku").val(newVariant['sku']);
    $("#prodId").val(newVariant['id']);
    if (this.product) {
      var options = this.product.options;
      var sizeOptionIndex = null;
      var colorOptionIndex = null;
      options.forEach((item, index) => {
        if (item.includes('Size')) sizeOptionIndex = index + 1;
        if (item.includes('Color')) colorOptionIndex = index + 1;
      });
      if (sizeOptionIndex) {
        $("#lineItemSizeProperty").val(newVariant['option'+sizeOptionIndex]);
      }
      if (colorOptionIndex) {
        $("#lineItemColorProperty").val(newVariant['option'+colorOptionIndex]);
      }
    }
    this._updateInventoryStatusUpdate(newVariant);
  };

  /**
   * Switch to the correct slideshow image
   */
  Plugin.prototype._updateInventoryStatusUpdate = function(newVariant) {
    var productForm = document.querySelector('.product__form');
    var message = document.querySelector(`#variant_inventorystatus_${newVariant['id']}`)?.value;
    var date = document.querySelector(`#variant_backorderdate_${newVariant['id']}`)?.value;
    var recipt_id = document.querySelector(`#item_atp_receipt_id_${newVariant['id']}`)?.value;
    var statusLineItem = document.querySelector('#variant_inventorystatus');
    var backorderdateLineItem = document.querySelector('#variant_backorderdate');
    var receiptIdLineItem = document.querySelector('#item_atp_receipt_id');
    if(message != "" && message != undefined && message != null) {
    } else {
      if(statusLineItem != undefined) {
        var parent = statusLineItem.parentNode;
        parent.removeChild(statusLineItem);
      }
    }
    backorderUpdates(date);
    if(!date && message){
      if(message.toLowerCase()=='backordered' && !itemTypeToShowBtnText ){
       $("#add-to-cart-btn").text("Pre-Order");
      }}
    if(date != "" && date != undefined && date != null) {
    } else {
      if(backorderdateLineItem != undefined) {
        var parent = backorderdateLineItem.parentNode;
        parent.removeChild(backorderdateLineItem);
      }
    }
    if(recipt_id != "" && recipt_id != undefined && recipt_id != null) {
      if(receiptIdLineItem == undefined) {
        receiptIdLineItem = document.createElement('INPUT');
        receiptIdLineItem.type = "hidden";
        receiptIdLineItem.name = "properties[_item_atp_receipt_id]";
        receiptIdLineItem.id = "item_atp_receipt_id";
        productForm.appendChild(receiptIdLineItem);
      }
      receiptIdLineItem.value = recipt_id;
    } else {
      if(receiptIdLineItem != undefined) {
        var parent = receiptIdLineItem.parentNode;
        parent.removeChild(receiptIdLineItem);
      }
    }
    function backorderUpdates(date) {
      var backorderD = $("#variant_back_orderdate").length;
      if(backorderD > 0){
        if(date != '' && date != null) {
          $("#add-to-cart-btn").text("Pre-Order");
          if(!$("#pre-order-tag-meta")[0]){
            $("#pre-order-tag").show();
          }
          const monthNames = ["January", "February", "March", "April", "May", "June",
            "July", "August", "September", "October", "November", "December"
          ];
          var newdate = date.split("-");
          var convertedDateFormat = newdate[2]+"-"+newdate[0]+"-"+newdate[1];
          const d = new Date(convertedDateFormat);
          //alert(monthNames[d.getUTCMonth()] + d.getUTCDate()+", "+ d.getUTCFullYear());
          if($(".ship-available-date")[0]){
            $(".ship-available-date").text(monthNames[d.getUTCMonth()] +" "+ d.getUTCDate()+", "+ d.getUTCFullYear());
          }else{
            if($(".additional-prod-info")[0]){
              $(".additional-prod-info").removeClass("4/10--lap-and-up").addClass("full-width 11/12--lap-and-up").append('<div class="additional-prod-info-fields additional-prod-date-fields grid__cell"><div class="left"><span class="shipping-icon"> </span></div><div class="right">Ships on or before '+monthNames[d.getUTCMonth()] +" "+ d.getUTCDate()+", "+ d.getUTCFullYear()+'</div></div>');
            }else{
              $(".prod-limits-dates").append('<div class="additional-prod-info grid 9/12--lap-and-up"><div class="additional-prod-info-fields additional-prod-date-fields grid__cell"><div class="left"><span class="shipping-icon"> </span></div><div class="right">Ships on or before '+monthNames[d.getUTCMonth()] +" "+ d.getUTCDate()+", "+ d.getUTCFullYear()+'</div></div></div>');
            }
          }
        } else {
          if($('.additional-prod-info-fields').length > 1) {
            $('.additional-prod-info-fields .additional-prod-date-fields').remove();
          } else {
            $('.additional-prod-info').remove();
          }
        }
      }
    }
  };

  /**
   * Switch to the correct slideshow image
   */
  Plugin.prototype._updateSlideshowImage = function(previousVariant, newVariant) {
    if (!newVariant || !newVariant['featured_media']) {
      return;
    }

    if (this.productSlides.length > 0) {
      this.productSlides.slick(
        'slickGoTo',
        parseInt(this.productSlides.find('[data-media-id="' + newVariant['featured_media']['id'] + '"]').attr('data-media-position'))
      );
    }

    if (this.context === 'homepage') {
      this.element.find('.product__featured-image[data-media-id="' + newVariant['featured_media']['id'] + '"]').show()
        .siblings().hide();
    }
  };

  /**
   * Update the prices. If the variant does not exist, we hide the prices completely
   */
  Plugin.prototype._updateProductPrices = function(previousVariant, newVariant) {
    if (!newVariant) {
      this.productPrices.each(function(index, element) {
        var parent = $(element).parent();

        if (parent.hasClass('form__control')) {
          parent.hide();
        } else {
          $(element).hide();
        }
      });
    } else {
      if (previousVariant && (previousVariant['price'] === newVariant['price']) && (previousVariant['compare_at_price'] === newVariant['compare_at_price'])) {
        return;
      }

      this.productPrices.empty();

      if (newVariant['compare_at_price'] > newVariant['price']) {
        this.productPrices.append('<span class="product__price product__price--new h4" data-money-convertible>' + Shopify.formatMoney(newVariant['price'], window.theme.moneyFormat) + '</span>');
        this.productPrices.append('<span class="product__price product__price--old h4" data-money-convertible>' + Shopify.formatMoney(newVariant['compare_at_price'], window.theme.moneyFormat) + '</span>');
      } else {
        this.productPrices.append('<span class="product__price h4" data-money-convertible>' + Shopify.formatMoney(newVariant['price'], window.theme.moneyFormat) + '</span>');
      }

      this.productPrices.show().parent().show();
    }
  };

  /**
   * Update the prices. If the variant does not exist, we hide the prices completely
   */
  Plugin.prototype._updateProductUnitPrices = function(previousVariant, newVariant) {
    var unitPriceMeasurement = this.element.find('.unit-price-measurement');

    if (!unitPriceMeasurement) {
      return; // Sometimes merchant remove element from the code without taking care of JS... so let's be defensive
    }

    if (!newVariant || !newVariant['unit_price_measurement']) {
      unitPriceMeasurement.parent().hide();
    } else {
      unitPriceMeasurement.parent().show();

      unitPriceMeasurement.find('.unit-price-measurement__price').html(Shopify.formatMoney(newVariant['unit_price'], window.theme.moneyFormat));
      unitPriceMeasurement.find('.unit-price-measurement__reference-unit').html(newVariant['unit_price_measurement']['reference_unit']);

      var unitPriceReferenceValue = unitPriceMeasurement.find('.unit-price-measurement__reference-value');
      unitPriceReferenceValue.html(newVariant['unit_price_measurement']['reference_value']);
      unitPriceReferenceValue.css('display', newVariant['unit_price_measurement']['reference_value'] === 1 ? 'none' : 'inline');
    }
  };

  /**
   * Update the selectors
   *
   * We have different kind of selectors: the size one, the color swatch and standard dropdown. When a new variant is selected, we must check the options
   * and prevent selection of unavailable and, if selected by the merchant, sold out variants
   */
  Plugin.prototype._updateSelectors = function(previousVariant, newVariant) {
    // No need to recompute the combinations if there is only one option
    if (!newVariant || this.product['options'].length <= 1) {
      return;
    }

    var option1 = newVariant['option1'],
      option2 = newVariant['option2'],
      option3 = newVariant['option3'],
      variantsCount = this.product['variants'].length;

    for (var i = 0 ; i != this.dataSelectors.length ; ++i) {
      var dataSelector = $(this.dataSelectors[i]),
        dataSelectorType = dataSelector.attr('data-selector-type'),
        optionIndex = (i + 1);

      // Check if optionsWithValues exists for this index
      if (!this.optionsWithValues[i]) {
        continue;
      }

      var optionValues = this.optionsWithValues[i]['values'];

      for (var j = 0 ; j != optionValues.length ; ++j) {
        var valueToCheck = optionValues[j],
          variantExists = false,
          allowVariantSelection = false,
          variantAvailable = false;

        if (optionIndex === 1) {
          for (var k = 0 ; k != variantsCount ; ++k) {
            var currentVariant = this.product['variants'][k];

            if (currentVariant['option1'] === valueToCheck && currentVariant['option2'] === option2 && currentVariant['option3'] === option3) {
              variantExists = true;
              variantAvailable = currentVariant['available'];

              break;
            }
          }
        } else if (optionIndex === 2) {
          for (var k = 0 ; k != variantsCount ; ++k) {
            var currentVariant = this.product['variants'][k];

            if (currentVariant['option1'] === option1 && currentVariant['option2'] === valueToCheck && currentVariant['option3'] === option3) {
              variantExists = true;
              variantAvailable = currentVariant['available'];

              break;
            }
          }
        } else if (optionIndex === 3) {
          for (var k = 0 ; k != variantsCount ; ++k) {
            var currentVariant = this.product['variants'][k];

            if (currentVariant['option1'] === option1 && currentVariant['option2'] === option2 && currentVariant['option3'] === valueToCheck) {
              variantExists = true;
              variantAvailable = currentVariant['available'];

              break;
            }
          }
        }

        if (variantExists) {
          if (variantAvailable || this.allowSelectingSoldOutVariants) {
            allowVariantSelection = true;
          }
        } else {
          allowVariantSelection = false;
        }

        if (dataSelectorType === 'size') {
          // For the size, we need to add the "product__size--unavailable" class and "disabled" to the input
          var sizeItem = dataSelector.find('.product__size').eq(j);

          if (allowVariantSelection) {
            sizeItem.removeClass('product__size--unavailable').find('> input').removeAttr('disabled')
              .next('label').attr('tabindex', 0);
          } else {
            sizeItem.addClass('product__size--unavailable').find('> input').attr('disabled', 'disabled')
              .next('label').removeAttr('tabindex');
          }
        } else if (dataSelectorType === 'color') {
          // For the color, we need to add the "product__color--unavailable" class and "disabled" to the input
          var colorItem = dataSelector.find('.product__color').eq(j);

          if (allowVariantSelection) {
            colorItem.removeClass('product__color--unavailable').find('> input').removeAttr('disabled')
              .next('label').attr('tabindex', 0);
          } else {
            colorItem.addClass('product__color--unavailable').find('> input').attr('disabled', 'disabled')
              .next('label').removeAttr('tabindex');
          }
        } else if (dataSelectorType === 'select') {
          // For the select, we need to add disabled to the option
          var optionItem = dataSelector.find('option').eq(j);

          if (allowVariantSelection) {
            optionItem.removeAttr('disabled');
          } else {
            optionItem.attr('disabled', 'disabled');
          }
        }
      }
    }
  };

  /**
   * Update the add to cart button
   */
  Plugin.prototype._updateAddToCartButton = function(previousVariant, newVariant) {
    // Check if we have payment button
    var smartPaymentButton = this.element.find('.shopify-payment-button');
    var $atcCartTypeEl = this.element.find('input[name="addToCartType"]');
    var atcType = $atcCartTypeEl ? $atcCartTypeEl.attr('value') : '';
    var isCombinedListing = this.element.find('#combinedListing').length > 0;
    if (isCombinedListing) return;
    if (!newVariant) {
      this.addToCartButton.attr('disabled', 'disabled')
        .removeClass('button--primary')
        .addClass('button--secondary')
        .text(window.languages.productFormUnavailable);

      smartPaymentButton.hide();
    } else {
      if (newVariant['available']) {
        var buttonText = atcType === 'pre-order' ? 'Pre-Order' : window.languages.productFormAddToCart;
        var paymentContainer = document.querySelector('.js-product-payment-container');
        var isCustomilyPdp = paymentContainer && paymentContainer.classList.contains('is-customily');
        var customilyLabel = window.languages.productFormPersonalize || window.languages.productFormCustomize;
        if (atcType !== 'pre-order' && isCustomilyPdp && customilyLabel) {
          buttonText = customilyLabel;
        }
        // Size-gated apparel keeps "Select Size" only until a size radio is chosen
        var sizeOptions = this.element.find('[data-selector-type="size"] input[type="radio"]');
        var needsSize = sizeOptions.length > 0 && sizeOptions.filter(':checked').length === 0;
        this.addToCartButton.toggleClass('needs-size', needsSize);
        if (needsSize && window.languages.productFormSelectSize) {
          buttonText = window.languages.productFormSelectSize;
        }
        this.addToCartButton.removeAttr('disabled')
          .addClass('button--primary')
          .removeClass('button--secondary')
          .text(buttonText);

        var $stickyAtc = $('.pdp-sticky-atc');
        if ($stickyAtc.length) {
          var $stickyLabel = $stickyAtc.find('.pdp-sticky-atc__label');
          if ($stickyLabel.length) {
            $stickyLabel.text(buttonText);
          } else {
            $stickyAtc.text(buttonText);
          }
        }

        smartPaymentButton.show();
      } else {
        this.addToCartButton.attr('disabled', 'disabled')
          .removeClass('button--primary')
          .addClass('button--secondary')
          .text(window.languages.productFormSoldOut);

        smartPaymentButton.hide();
      }
    }
  };

  /**
   * ---------------------------------------------------------------------------------------------------
   * INTERNAL CODE THAT HANDLE VARIANT CHANGES
   * ---------------------------------------------------------------------------------------------------
   */

  /**
   * This call back is called whenever a property in one of the select or radio button has changed
   */
  Plugin.prototype._onSelectorChanged = function() {
    var previousVariant = this.currentVariant;

    this.currentVariant = this._getVariantFromOptions();
    this._onVariantChanged(previousVariant, this.currentVariant);

    if (this.currentVariant) {
      if (this.enableHistoryState) {
        this._updateHistoryState(this.currentVariant);
      }

      // We need to modify the hidden select that contain the id attribute as well
      this.masterSelector.find('[selected]').removeAttr('selected');
      this.masterSelector.find('[value="' + this.currentVariant['id'] + '"]').prop('selected', true);
    }

    // We also trigger an event so that other system can hookup and perform additional changes
    $(document).trigger('variant_changed.product', this.currentVariant);
    let upsellcontainer = $(".upsell-container ");
    if(upsellcontainer.length>0){
      let p_id = $("#product_id_g").val();
      p_id = parseInt(p_id);
      let upsell_p = upsellcontainer.find(".upsell-products");
      let upsell_pid = upsell_p.attr('p_id_parent');
      upsell_pid = parseInt(upsell_pid);
      if(p_id == upsell_pid){
        upsellcontainer.find(".upsell-products[p_id_parent='"+upsell_pid+"']").attr('id', this.currentVariant.id);
      }
    }
  };

  /**
   * Update the HTML history state
   */
  Plugin.prototype._updateHistoryState = function(variant) {
    if (!history.replaceState) {
      return;
    }

    var newUrl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
    window.history.replaceState({path: newUrl}, '', newUrl);
  };

  /**
   * Get the variant that is currently selected
   */
  Plugin.prototype._getVariantFromOptions = function() {
    var selectedValues = this._getCurrentOptions();
    var variants = this.product['variants'];
    var found = false;

    variants.forEach(function(variant) {
      var satisfied = true;
      selectedValues.forEach(function(option) {
        if (satisfied) {
          satisfied = (option.value === variant[option.index]);
          if (option.isCombined) {
            satisfied = (Number(option.value) === variant.id);
          }
        }
      });

      if (satisfied) {
        found = variant;
      }
    });

    return found || null;
  };

  /**
   * Extract all the current options
   */
  Plugin.prototype._getCurrentOptions = function() {
    let options = this.singleOptionSelectors;
    let isCombined = false;
    if (this.combinedSelector.length) {
      options = this.combinedSelector;
      isCombined = true;
    }

    var currentOptions = options.toArray().map(function(element) {
      var $element = $(element),
        type = $element.attr('type'),
        index = $element.attr('data-option-index');

      if (type === 'radio' || type === 'checkbox') {
        if ($element[0].checked) {
          return {value: $element.val(), index: index};
        } else {
          return false;
        }
      } else {
        return {value: $element.val(), index: index, isCombined};
      }
    });

    // remove any unchecked input values if using radio buttons or checkboxes

    return currentOptions.filter(function(item) {
      return item;
    });
  };

  /**
   * Variant currently selected on a combined listing, or null on a regular PDP.
   * The variant field is a <select> here, so it cannot be read as input[name="id"].
   */
  function getCombinedListingVariantId() {
    if (!document.getElementById('combinedListing')) return null;

    const $form = document.querySelector('form[action*="/cart/add"]');
    const $variantField = $form ? $form.querySelector('[name="id"]') : null;
    if ($variantField && $variantField.value) return $variantField.value;

    const $productsToAdd = document.getElementById('products-to-add');
    return $productsToAdd && $productsToAdd.value ? $productsToAdd.value : null;
  }

  /**
   * Total quantity of the current product across every cart line
   */
  function getProductQtyInBag() {
    const { bagItems } = SDG.Data;
    if (!Array.isArray(bagItems)) return 0;

    const selectedVariantId = getCombinedListingVariantId();
    const isCombinedListing = selectedVariantId !== null;

    return bagItems.reduce(function(total, item) {
      const itemVariantId = item.variant_id != null ? item.variant_id : item.id;
      const matches = isCombinedListing
        ? String(itemVariantId) === String(selectedVariantId)
        : item.handle === SDG.Data.productHandle;

      return matches ? total + (item.quantity || 0) : total;
    }, 0);
  }

  /**
   * Get available membership variant IDs from dropdown
   */
  function getAvailableMembershipIds() {
    const $membershipsSelect = document.querySelector('.js-memberships-select');
    if (!$membershipsSelect) return [];

    const availableMembershipIds = [];
    Array.from($membershipsSelect.options).forEach(option => {
      if (option.value && option.value !== '') {
        availableMembershipIds.push(parseInt(option.value));
      }
    });

    return availableMembershipIds;
  }

  /**
   * Whether a membership offered by this PDP is already in the bag
   */
  function isMembershipInCart() {
    const $membershipsWrap = document.querySelector('.js-memberships-wrap');
    if (!$membershipsWrap) return false;

    const { bagItems } = SDG.Data;
    if (!bagItems || bagItems.length === 0) return false;

    const availableMembershipIds = getAvailableMembershipIds();
    if (availableMembershipIds.length === 0) return false;

    return bagItems.some(item => {
      const itemProperties = item.properties || item.full_data?.properties;
      const isDigitalMembership = itemProperties?._is_digital_membership === 'true';
      if (!isDigitalMembership) return false;

      const itemId = item.id || item.variant_id || item.full_data?.id;
      return availableMembershipIds.includes(itemId);
    });
  }

  /**
   * Check if this is a multi-membership PDP and re-enable button if membership not in cart
   */
  Plugin.prototype._checkMultiMembershipButtonState = function() {
    const $membershipsWrap = document.querySelector('.js-memberships-wrap');
    if (!$membershipsWrap) return; // Not a multi-membership PDP

    const { bagItems } = SDG.Data;
    if (!bagItems || bagItems.length === 0) return; // Cart is empty, button should be enabled anyway

    const availableMembershipIds = getAvailableMembershipIds();
    if (availableMembershipIds.length === 0) return;

    // Check if any cart item is a membership that matches this product's available memberships
    const membershipInCart = isMembershipInCart();

    // Check if main product limit is reached
    const mainProductQtyInCart = getProductQtyInBag();
    const mainProductLimit = SDG.Data.productQtyLimit || 0;
    const isMainProductLimitReached = mainProductLimit > 0 && mainProductQtyInCart >= mainProductLimit;

    // If limit is reached but membership is NOT in cart, re-enable the button
    if (isMainProductLimitReached && !membershipInCart) {
      this.addToCartButton.removeAttr('disabled').removeClass('disabled-btn').removeClass('sold-out-btn');
      $('.pdp-sticky-atc').removeAttr('disabled').removeClass('disabled-btn').removeClass('sold-out-btn');
      // Hide the limit warning message if it exists
      $('.warning-msg.limited').hide();
    }
    // If both conditions are met (limit reached AND membership in cart), ensure button is disabled
    else if (isMainProductLimitReached && membershipInCart) {
      this.addToCartButton.attr('disabled', 'disabled').addClass('disabled-btn');
      $('.pdp-sticky-atc').attr('disabled', 'disabled').addClass('disabled-btn');
    }
  };

  /**
   * Disable the add to cart CTAs and surface the purchase limit message
   * @param {boolean} scrollIntoView Scroll to the message (only on a user action)
   */
  Plugin.prototype._showPurchaseLimitReached = function(scrollIntoView) {
    // Multi-membership PDPs stay enabled so the membership can still be added
    if (document.querySelector('.js-memberships-wrap') && !isMembershipInCart()) return;

    this.addToCartButton.attr('disabled', 'disabled').addClass('disabled-btn js-limit-disabled');
    $('.pdp-sticky-atc').attr('disabled', 'disabled').addClass('disabled-btn js-limit-disabled');

    if (this.element.find('#combinedListing').length > 0) {
      this.element.find('.js-combined-listing-atc-qty-error').show().each(function () {
        if (scrollIntoView && typeof scrollPdpErrorIfVisible === 'function') scrollPdpErrorIfVisible(this);
      });
      return;
    }

    if ($('.warning-msg.limited').length === 0) {
      var limitBy = $('#product_limit').val();
      var errorH = '<p class="warning-msg bold limited" style="display:block"><i class="icon icon--error-exclamation-small"></i> You have reached the limit of ' + limitBy + ' per order.</p>';
      $('.product__add-to-cart').parents('#non-rlc-container').prepend(errorH);
    } else {
      $('.warning-msg.limited').show();
    }

    if (scrollIntoView && typeof scrollPdpErrorIfVisible === 'function') {
      scrollPdpErrorIfVisible(document.querySelector('.warning-msg.limited'));
    }
  };

  /**
   * Undo the purchase limit state, leaving CTAs disabled for any other reason alone
   */
  Plugin.prototype._clearPurchaseLimitReached = function() {
    this.addToCartButton.filter('.js-limit-disabled')
      .removeAttr('disabled').removeClass('disabled-btn js-limit-disabled');
    $('.pdp-sticky-atc.js-limit-disabled')
      .removeAttr('disabled').removeClass('disabled-btn js-limit-disabled');

    $('.warning-msg.limited').remove();
    this.element.find('.js-combined-listing-atc-qty-error').hide();
  };

  /**
   * Keep the PDP CTAs in step with the purchase limit as the bag changes, so the
   * limit is reflected straight away instead of only after a page refresh
   */
  Plugin.prototype._syncPurchaseLimitState = function() {
    const productQtyLimit = Number(SDG.Data.productQtyLimit) || 0;
    if (productQtyLimit <= 0) return;

    if (getProductQtyInBag() >= productQtyLimit) {
      this._showPurchaseLimitReached(false);
    } else {
      this._clearPurchaseLimitReached();
    }
  };

  /**
   * ---------------------------------------------------------------------------------------------------
   * INTERNAL CODE THAT HANDLE PRODUCT ADD TO CART
   * ---------------------------------------------------------------------------------------------------
   */

   Plugin.prototype._addToCart = function(event) {
    var self = this;
    var addtoBtn = self.addToCartButton;
    var allowLimit = 0;
    var btnHit = 0;
    var limitCheck = false;

    const $membershipsSelect = document.querySelector('.js-memberships-select');
    const membershipSelectDisabled = $membershipsSelect ? $membershipsSelect.disabled : undefined;

    function errorMsg(){
      self._showPurchaseLimitReached(true);
    }

    function addCode(btnHit,allowLimit){
      const serializedForm = self.element.find('form.js-product-form').serialize();
      const isRestrictedProduct = serializedForm.includes('restricted_cart');
      const isSellingPlanProduct = serializedForm.includes('selling_plan');
      const bagHasPreOrder = SDG.Data.bagItems
        .find((item) => item.selling_plan_allocation?.selling_plan || item.full_data?.properties?._restricted_cart);
      let hasLegacyMembershipUpsell = false;

      const isSizedProduct = self.addToCartButton === 'productSizeSubmit';
      const noSizeSelected = isSizedProduct && self.addToCartButton.classList.contains('product__add-to-cart');

      if ($(".digital-memb").length) {
        const isChecked = $(".digital-memb").is(":checked");
        const isDisabled = $(".digital-memb").is(":disabled");
        const isDigitalMembership = SDG?.Data?.isDigitalMembership && !$(".grid__membership-upsell").length;
        const isExclusiveMember = typeof SDG?.Data?.isExclusiveMember === 'string' ? SDG?.Data?.isExclusiveMember?.split(',').includes(SDG?.Data?.exclusiveBrand) : SDG?.Data?.isExclusiveMember;
        const isExclusiveCustomer = SDG?.Data?.isCustomer && isExclusiveMember;

        const shouldApplyErrorStyles =
          !isChecked &&
          !isDisabled &&
          !isDigitalMembership &&
          (!SDG?.Data?.isCustomer || !isExclusiveCustomer);

        if (shouldApplyErrorStyles) {
          const closestParentGrid = $(".digital-memb").closest(".grid");
          closestParentGrid.css("border", "1px solid #ee0224");
          $(".digital-memb").siblings("label").css({
            "background": "none",
            "border": "1px solid red"
          });
          return;
        }
      }


      if (SDG.Data.isPodProduct) {
        const selectedCombinedListingVariant = self.element.find('.js-combined-fieldset:not(.hide) .js-combined-item-input-size:checked');
        const selectedCombinedListingText = self.element.find('.js-combined-fieldset:not(.hide) .product-combined__fieldset-selection');

        if (!selectedCombinedListingVariant.length) {
          const $podError = self.element.find('.js-pod-needs-variant-select');

          if ($podError) {
            const $textContent = self.element.find('.js-pod-needs-variant-select-text');
            $($textContent).text('Please select the' + selectedCombinedListingText.text().replace(':', ''));
            $($podError).css({
              "display": "block"
            });
            if (typeof scrollPdpErrorIfVisible === 'function') {
              scrollPdpErrorIfVisible($podError[0]);
            }
          }
          return;
        }
      }

      const closestParentGrid = $(".digital-memb").closest(".grid");
      closestParentGrid.css("border", "1px solid #7b7b7b");
      $(".product__membership-error").addClass("hide");

      if (isSizedProduct && !noSizeSelected) return;
      if ($(".digital-memb").length) {
        hasLegacyMembershipUpsell = true;
      }

      if (hasLegacyMembershipUpsell || SDG.Data.isDigitalMembership) return; // use logic in custom.js.liquid

      const { bagItems } = SDG.Data;

      const openMixedCartModal = () => {
        SDG.Data.mixedCartModalUk.open();
        self.addToCartButton.removeAttr('disabled').removeClass('button--loading');
      }

      if (SDG.Data.isUk) {
        const productId = self.element.find('form[action*="/cart/add"] input[name="product-id"]').val();
        const preOrderInCart = bagItems.find(
          (item) => {
            if (item.properties) {
              return item.properties._is_preorder === 'true';
            }
            if (item.full_data) {
              return item.full_data?.properties?._is_preorder === 'true';
            }
            return false;
          }
        );

        if (SDG.Data.isPreOrder) {
          const isDigitalMembership = (item) => {
            if (item.properties) {
              return item.properties._is_digital_membership === 'true';
            }
            if (item.full_data?.properties) {
              return item.full_data.properties._is_digital_membership === 'true';
            }
            return false;
          };

          const otherSkuInCart = bagItems.some(
            (item) =>
              item.product_id !== parseInt(productId, 10) &&
              !isDigitalMembership(item)
          );

          if (otherSkuInCart) {
            openMixedCartModal();
            return;
          }
        } else if (preOrderInCart && !SDG.Data.isDigitalMembership) {
          openMixedCartModal();
          return;
        }
      }

      const { pathname, search } = window.location;
      const urlParams = new URLSearchParams(window.location.search);
      const paramsObject = Object.fromEntries(urlParams);
      // On a combined listing the URL and the parent handle both lag behind the
      // selected child, so the cart line has to be matched on the selected variant.
      const combinedListingVariantId = getCombinedListingVariantId();
      const [sameItem] = bagItems.filter((item) => (combinedListingVariantId
        ? String(item.id) === String(combinedListingVariantId)
        : item.handle === pathname.replace('/products/', '') || paramsObject?.variant === `${item.id}`));
      const hasMembership = $membershipsSelect && (($membershipsSelect.value && $membershipsSelect.value !== '') || $membershipsSelect.disabled === true);
      const formToObject = Object.fromEntries(new FormData(self.element.find('form[action*="/cart/add"]')[0]));
      const $productGwpSection = document.querySelector('.js-product-gwp');
      if (!hasMembership && isRestrictedProduct && bagItems.length > 0) {
        if (sameItem) {
          updateItemQty(sameItem);
        } else {
          SDG.Data.mixedCartModal.open('modalMixedCart');
        }
        self.addToCartButton.removeAttr('disabled').removeClass('button--loading');
        return; // escape function
      } else if (!isRestrictedProduct && bagHasPreOrder && !hasMembership && !isSellingPlanProduct) {
        SDG.Data.mixedCartModal.open('modalMixedCart');
        self.addToCartButton.removeAttr('disabled').removeClass('button--loading');
        return;
      }

      if (addtoBtn.is('[allow-limit]') && bagItems.length > 0) {
        // A limit of 0 means "no limit". Prefer the button's own value, which is
        // rewritten per combined listing child and so cannot go stale here.
        const productQtyLimit = Number(addtoBtn.attr('allow-limit')) || Number(SDG.Data.productQtyLimit) || 0;
        const quantityToAdd = Number(formToObject.quantity) || 1;

        if (productQtyLimit > 0 && (getProductQtyInBag() + quantityToAdd) > productQtyLimit) {
          errorMsg();
          self.addToCartButton.removeClass('button--loading');
          return;
        } else if (sameItem && !hasMembership) {
          const hasActiveGwpSelection = formToObject.gwp
            && $productGwpSection
            && !$productGwpSection.classList.contains('product-gwp--disabled');
          if (!hasActiveGwpSelection) {
            updateItemQty(sameItem, Number(formToObject.quantity));
            return;
          }
        }
      }

      let data = serializedForm;

      const { components } = SDG.Data;
      if ($(".digital-memb").length) {
        formToObject.memberships = $(".digital-memb").attr('id');
      }
      self.addToCartButton.attr('disabled', 'disabled').addClass('button--loading');

      if (SDG.Data.isUk && SDG.Data.isPreOrder) {
        data += '&properties[_is_preorder]=true';
      }

      const hasAddOn = serializedForm.includes('add-on-');
      // Components or GWP
      if ((components && components.length) || formToObject.gwp || hasAddOn || hasMembership || hasLegacyMembershipUpsell) {
        const properties = {};

        Object.keys(formToObject).forEach((key) => {
          const value = formToObject[key];
          if (key.includes('properties')) {
            let prop = key.split('[');
            prop = prop[1].replaceAll(']', '');
            properties[prop] = value;
          }
        });

        const reference = SDG.randomId(25);

        // Parent product data
        let dataObj = {
          items: [],
        };

        // Componnest data
        if (components && components.length) {
          SDG.Data.components.forEach((id, index) => {
            let type = 'child';
            // if product is tagged as bundle, the main product is not added to the cart
            // only products from 'Component:' tag
            if (index === 0) type = 'parent';

            const componentData = {
              quantity: formToObject.quantity,
              id,
              properties: {
                ...properties,
                _type: type,
                _reference: reference,
                _bundle_variant_id: self.product.variants[0].id,
              },
            }

            dataObj.items.push(componentData);
          });
        }

        // GWP Data
        if (formToObject.gwp) {
          SDG.Data.gwpIncluded = 2;
          const parentRef = SDG.randomId(25);
          const gwpRef = SDG.randomId(25);
          const mainProductData = {
            quantity: formToObject.quantity,
            id: formToObject.id,
            properties: {
              ...properties,
              _reference: parentRef,
            },
          }

          const gwpData = {
            quantity: 1,
            id: formToObject.gwp,
            properties: {
              _reference: gwpRef,
              _gwp: 'true',
            },
          }

          dataObj.items.push(gwpData);
          dataObj.items.push(mainProductData);
        }

        if (hasAddOn) {
          SDG.Data.gwpIncluded = 1;
          const mainProductData = {
            quantity: formToObject.quantity,
            id: formToObject.id,
            properties: {
              ...properties,
              _reference: SDG.randomId(25),
            },
          };

          Object.entries(formToObject).forEach(([key, value]) => {
            if (key.includes('add-on-')) {
              const addOnId = value;
              const addOnProductData = {
                quantity: 1,
                id: addOnId,
                properties: {
                  _reference: SDG.randomId(25),
                },
              };
              SDG.Data.gwpIncluded += 1;
              dataObj.items.push(addOnProductData);
            }
          });

          dataObj.items.push(mainProductData);
        }

        if (hasMembership) {
          const parentRef = SDG.randomId(25);
          const membershipRef = SDG.randomId(25);
          const {bagItems} = SDG.Data;
          const membershipInCart = bagItems.find(item => (item.id || item.full_data.id) === parseInt(formToObject.memberships));
          const mainProductInCart = bagItems.find(item => (item.id || item.full_data.id) === parseInt(formToObject.id));

          // Check if main product limit is reached
          const [sameItem] = bagItems.filter((item) => item.handle === SDG.Data.productHandle);
          const mainProductQtyInCart = sameItem ? sameItem.quantity : 0;
          const mainProductLimit = SDG.Data.productQtyLimit || 0;
          const isMainProductLimitReached = mainProductLimit > 0 && mainProductQtyInCart >= mainProductLimit;

          const mainProductData = {
            quantity: formToObject.quantity,
            id: formToObject.id,
            properties: {
              ...properties,
              _reference: mainProductInCart ? (mainProductInCart.properties?._reference || mainProductInCart?.reference) : parentRef,
            },
          }

          const membershipData = {
            quantity: 1,
            id: formToObject.memberships,
            properties: {
              _is_digital_membership: 'true',
              _agreement_checked: 'true',
              _membership_no_agreement: 'false',
              _reference: membershipInCart ? (membershipInCart.properties?._reference || membershipInCart?.reference) : membershipRef,
            },
          }

          if ($membershipsSelect) {
            if (!membershipSelectDisabled) dataObj.items.push(membershipData);
          } else dataObj.items.push(membershipData);

          // Only add main product if limit is not reached or if there's an add-on
          if (!hasAddOn && !isMainProductLimitReached) {
            dataObj.items.push(mainProductData);
          }
        }

        if (hasLegacyMembershipUpsell) {
          const parentRef = SDG.randomId(25);
          const membershipRef = SDG.randomId(25);
          const {bagItems} = SDG.Data;
          const membershipInCart = bagItems.find(item => (item.id || item.full_data.id) === parseInt(formToObject.memberships));
          const mainProductInCart = bagItems.find(item => (item.id || item.full_data.id) === parseInt(formToObject.id));

          const mainProductData = {
            quantity: formToObject.quantity,
            id: formToObject.id,
            properties: {
              ...properties,
              _reference: mainProductInCart ? (mainProductInCart.properties?._reference || mainProductInCart?.reference) : parentRef,
            },
          }

          const membershipData = {
            quantity: 1,
            id: formToObject.memberships,
            properties: {
              _is_digital_membership: 'true',
              _agreement_checked: 'true',
              _membership_no_agreement: 'false',
              _reference: membershipInCart ? (membershipInCart.properties?._reference || membershipInCart?.reference) : membershipRef,
            },
          }

          dataObj.items.push(membershipData);
          SDG.Data.gwpIncluded += 1; // only count membership
          if (!hasAddOn) {
            dataObj.items.push(mainProductData);
          }
        }

        data = dataObj;
      }

      const hasPreOrderInCart = SDG.Data.bagItems
        .find((item) => item.full_data?.properties?._is_preorder === 'true' || item.properties?._is_preorder === 'true' || item.selling_plan_allocation);  // eslint-disable-line
      const { isUk } = SDG.Data;
      if (hasPreOrderInCart && isUk) {
        if (!SDG.Data.isPreOrder) {
          SDG.Data.mixedCartModal.open('modalMixedCart');
          return self.addToCartButton.removeAttr('disabled').removeClass('button--loading');
        }
      }

      if (SDG.Data.isPodProduct) {
        const previewUrlLineProperty = document.querySelector('.product__slideshow:not(.hide) .product__slide--image');
        if (previewUrlLineProperty) {
          data += `&properties[_bg_previewUrl]=${previewUrlLineProperty.dataset.mfpSrc}`;
        }
        const cldBgPublicId = document.querySelector('input[name="properties[_cld_bg_publicId]"]');
        if (cldBgPublicId) {
          data += `&properties[_cld_bg_publicId]=${cldBgPublicId.value}`;
        }
        data += `&properties[_combined_listing_url]=/products/${SDG.Data.productHandle}`;
      }

      // Then we add the product in Ajax
      $.ajax({
        method: 'POST',
        url: Shopify.routes.root + 'cart/add.js',
        dataType: 'json',
        data: data,
      }).then(function(successData) {
        if (hasMembership) {
          SDG.memnbershipsDropdownReset();
        }
        if (successData) {
          SDG.Data.itemsAddedToCart = (successData.items && Array.isArray(successData.items) && successData.items.length)
            ? successData.items
            : (successData.id || successData.variant_id) ? [successData] : null;
          if (successData.items && Array.isArray(successData.items) && successData.items.length) {
            SDG.Data.itemsAddedToCartQty = successData.items.length;
          }
        }

        const $membershipWrap = document.querySelector('.js-memberships-wrap');
        if ($membershipWrap) $membershipWrap.classList.add('pv-memberships--disabled');
        if ($membershipsSelect) $membershipsSelect.disabled = true;

        if (SDG?.Data?.isCustomilyPdp) {
          // Customily does not automatically remove the `disable-scroll` class when
          // items are added to the cart, so we need to manually remove it here
          $('html').removeClass('disable-scroll');
        }

        $.ajax({
          method: 'GET',
          url: Shopify.routes.root + 'cart.js',
          dataType: 'json',
        }).then(function(cart) {
          return $.ajax({
            method: 'GET',
            url: Shopify.routes.root + 'cart?view=data',
            dataType: 'json',
          }).then(function(items) {
            window.SDG.Data.bagItems = Array.isArray(items) ? items : cart.items;
            return cart;
          }, function() {
            window.SDG.Data.bagItems = cart.items;
            return cart;
          });
        }).then(function(cart) {
          const qtyAdded = successData.quantity || 1;
          var lineItems = window.SDG.Data.bagItems;
          if (Array.isArray(lineItems)) {
            cart.items = lineItems;
          }
          var crAllowLimit = null;
          if (typeof addtoBtn.attr('allow-limit') !== 'undefined' && addtoBtn.attr('allow-limit') != null) {
            var maxLimit = parseInt($('#product_limit').val(), 10) || SDG.Data.productQtyLimit || parseInt(addtoBtn.attr('allow-limit'), 10);
            var productHandle = SDG.Data.productHandle || (window.location && window.location.pathname.replace('/products/', ''));
            var totalSameProductQty = (cart.items || []).filter(function(item) { return item.handle === productHandle; }).reduce(function(sum, i) { return sum + (i.quantity || 0); }, 0);
            crAllowLimit = Math.max(0, maxLimit - totalSameProductQty);
            addtoBtn.attr('allow-limit', crAllowLimit);
          }

          if (crAllowLimit !== null && crAllowLimit <= 0) {
            errorMsg();
          }

          $(document).trigger('theme:cart:updated', [cart, true, true]);
          var cartCount = $(".header__cart-count:first").text().trim();
          if(cartCount!="0"){
            $(".header__cart-count").css("display","block");
          }else{
            $(".header__cart-count").css("display","none");
          }
          self.addToCartButton.removeAttr('disabled').removeClass('button--loading');
          $('.pdp-sticky-atc').removeAttr('disabled').removeClass('button--loading pdp-sticky-atc--loading');
          if ($(".non-rlc-btn")[0]){
            //$( "#non-rlc-container" ).load(window.location.href + " #non-rlc-container" );
          }

          // Adding Klaviyo tracking for added to cart
          const _learnq = window._learnq || []; // eslint-disable-line
          if (_learnq) {
            _learnq.push(['track', 'Added to Cart', {
              total_price: cart.total_price/100,
              $value: cart.total_price/100,
              total_discount: cart.total_discount,
              original_total_price: cart.original_total_price/100,
              items: cart.items
            }]);
          }

          const cartId = cart.token;
          const $crossSellInput = $('input[properties="_cross_sell_product_sku"]').val();
          const $upgradeOption = $('input[properties="_upgrade_option"]').val();
          const $addToCartType = $('#pdpAddToCartType').val();
          const evergreenType = $('#pdpEvergreenValue').val();
          const crossSellProduct = $crossSellInput ? true : false;
          const crossSellProductSku = $crossSellInput ? $crossSellInput : '';
          const { properties } = successData;
          let $badge = $('#pdp_badge').val();
          let $category1 = $('#pdpProductCategory').val();
          let $category2 = $('#pdpProductCategory2').val();
          let couponText = $('#pdpCouponText').val();
          let $ageGrade = $('#pdp_age_grade').val();
          let itemSize = undefined;
          let itemColor = undefined;
          let itemBunleId = undefined;

          if (properties) {
            if (properties._line_item_size) itemSize = properties._line_item_size;
            if (properties._line_item_color) itemColor = properties._line_item_color;
            if (properties._item_bundle_id) itemBunleId = properties._item_bundle_id;
          }


          let hasGwp = false;
          if (data.items && data.items.length > 1) {
            data.items.forEach((item) => {
              if (item.properties && item.properties._gwp === 'true') {
                hasGwp = true;
              }
            });
          }

          const itemsData = [];
          if (successData.items) {
            successData.items.forEach((item, index) => {
              if (item.properties && item.properties['_gwp'] === 'true') {
                const $selectedInput = document.querySelector('.js-product-gwp-input:checked');
                const gwpItem = $selectedInput.closest('.js-gwp-product');
                const gwpCategory1 = gwpItem.querySelector('#gwpProductCategory')?.value || '';
                const gwpcategory2 = gwpItem.querySelector('#gwpProductCategory2')?.value || '';
                const gwpItemSize = gwpItem.querySelector('#gwpItemSize')?.value || '';
                const gwpItemColor = gwpItem.querySelector('#gwpItemColor') ? gwpItem.querySelector('#gwpItemColor')?.value : '';
                const gwpCrossSellProduct = gwpItem.querySelector('#gwpCrossSellProductSku')?.value !== '';
                const gwpCrossSellProductSku = gwpItem.querySelector('#gwpCrossSellProductSku')?.value || '';
                const discountPrice = gwpItem.querySelector('#gwpDiscountAmount')?.value || '';
                const gwpAgeGrade = gwpItem.querySelector('#gwpAgeGrade')?.value || '';
                const gwpItemPromo = gwpItem.querySelector('#gwpCoupon')?.value || undefined;
                itemsData.push({
                  'index': 2,
                  'age_group': gwpAgeGrade || '',
                  'evergreen': evergreenType,
                  'item_id': item.sku?.split('_')[0],
                  'item_sku': item.sku,
                  'item_badge': $badge || '',
                  'item_list_type': item.properties?._item_list_type || undefined,
                  'item_name': item.title,
                  'item_brand': item.vendor,
                  'item_category': gwpCategory1,
                  'item_category2': gwpcategory2 || '',
                  'merch_vendor': item.vendor,
                  'product_availability': 'available',
                  'price': Shopify.formatMoney(0, '{{amount}}'),
                  'discount': discountPrice,
                  'original_price': Shopify.formatMoney(item.original_price, '{{amount}}'),
                  'item_bundle': 'false',
                  'item_bundle_sku': '',
                  'item_bundle_id': itemBunleId,
                  'item_variant': item.id,
                  'item_size': gwpItemSize,
                  'item_color': gwpItemColor,
                  'quantity': item.quantity,
                  'cross_sell_product': gwpCrossSellProduct,
                  'cross_sell_product_sku': gwpCrossSellProductSku,
                  'upgrade_option': '',
                  'item_promo':  gwpItemPromo,
                  'coupon': undefined,
                })
              } else { // bundled items added to cart
                if (couponText === 'automatic_discount' && item.total_discount === 0) {
                  couponText = ''; // reset variable for parent since promo does not apply
                } else if (item.total_discount === 0) {
                  couponText = '';
                } else {
                  couponText = $('#pdpCouponText').val();
                }
                const automaticCouponText = couponText === 'automatic_discount'
                  && item.discounts.length > 0
                  && item.total_discount > 0
                  ? $('#pdpAutomaticDiscount').val() : undefined;
                const lineItemAppliedDiscount = item.line_level_total_discount;
                const compareAtPriceDiscount = item.original_price - item.line_price;
                const $addOnCheckbox = document.querySelector(`.js-product-add-on-link[data-variant="${item.id}"]`);

                if ($addOnCheckbox) {
                  $ageGrade = $addOnCheckbox.dataset.ageGrade;
                  $badge = $addOnCheckbox.dataset.badge;
                  $category1 = $addOnCheckbox.dataset.category;
                  $category2 = $addOnCheckbox.dataset.category2;
                } else {
                  $ageGrade = $('#pdp_age_grade').val()
                  $badge = $('#pdp_badge').val();
                  $category1 = $('#pdpProductCategory').val();
                  $category2 = $('#pdpProductCategory2').val();
                }

                itemsData.push({
                  'index': index,
                  'age_group': $ageGrade || undefined,
                  'evergreen': evergreenType,
                  'item_id': item.sku?.split('_')[0],
                  'item_sku': item.sku,
                  'item_badge': $badge || undefined,
                  'item_list_type': item.properties?._item_list_type || undefined,
                  'item_name': item.title,
                  'item_brand': item.vendor,
                  'item_category': $category1,
                  'item_category2': $category2 || undefined,
                  'merch_vendor': item.vendor,
                  'product_availability': 'available',
                  'price': __.formatPrice(item.line_price),
                  'discount': __.formatPrice(lineItemAppliedDiscount > 0 ? lineItemAppliedDiscount : compareAtPriceDiscount),
                  'original_price': __.formatPrice(item.original_price),
                  'item_bundle': 'false',
                  'item_bundle_sku': undefined,
                  'item_bundle_id': itemBunleId,
                  'item_variant': item.id,
                  'item_size': itemSize,
                  'item_color': itemColor,
                  'quantity': item.quantity,
                  'cross_sell_product': crossSellProduct,
                  'cross_sell_product_sku': crossSellProductSku,
                  'upgrade_option': $upgradeOption || undefined,
                  'item_promo': couponText !== '' ? automaticCouponText : undefined,
                  'coupon': undefined, // new mapped discount data from successdata
                });
              }
            });
          } else { // default single product atc logic
            itemsData.push({
              'index': 1,
              'age_group': $ageGrade || undefined,
              'evergreen': evergreenType,
              'item_id': successData.sku?.split('_')[0],
              'item_sku': successData.sku,
              'item_badge': $badge || undefined,
              'item_list_type': properties?._item_list_type || undefined,
              'item_name': successData.title,
              'item_brand': successData.vendor,
              'item_category': $category1,
              'item_category2': $category2 || undefined,
              'merch_vendor': successData.vendor,
              'product_availability': 'available',
              'price': Shopify.formatMoney(successData.final_price, '{{amount}}'),
              'discount': $('#discount-amount').val(),
              'original_price': Shopify.formatMoney(successData.original_price, '{{amount}}'),
              'item_bundle': 'false',
              'item_bundle_sku': '',
              'item_bundle_id': itemBunleId,
              'item_variant': successData.id,
              'item_size': itemSize,
              'item_color': itemColor,
              'quantity': successData.quantity,
              'cross_sell_product': crossSellProduct,
              'cross_sell_product_sku': crossSellProductSku,
              'upgrade_option': $upgradeOption || undefined,
              'item_promo': couponText !== '' && couponText !== 'automatic_discount' ? couponText : undefined,
              'coupon': undefined,
            });
          }

          window.dataLayer.push({ ecommerce: null });
          window.dataLayer.push({
            'event': 'add_to_cart',
            'ecommerce': {
              'currency': Shopify.currency.active,
              'cart_id': cartId,
              'add_to_cart_type': $addToCartType,
              ...(SDG.Data.customerEmail !== null && {authentication_status: true}),
              ...(SDG.Data.customerEmail === null && {authentication_status: false}),
              'items': itemsData,
            }
          });

          // Update the quantity selector
          if (window.SDG.updateQuantitySelector) {
            window.SDG.updateQuantitySelector();
          }

          // For multi-membership PDPs, explicitly check and disable button if both conditions met
          const $membershipsWrap = document.querySelector('.js-memberships-wrap');
          if ($membershipsWrap && hasMembership) {
            // Check if membership was just added and main product is at limit
            const membershipJustAdded = isMembershipInCart();
            const { pathname } = window.location;
            const [sameItem] = window.SDG.Data.bagItems.filter((item) => item.handle === pathname.replace('/products/', ''));
            const mainProductQtyInCart = sameItem ? sameItem.quantity : 0;
            const mainProductLimit = SDG.Data.productQtyLimit || 0;
            const isMainProductLimitReached = mainProductLimit > 0 && mainProductQtyInCart >= mainProductLimit;

            if (membershipJustAdded && isMainProductLimitReached) {
              // Both conditions met: disable the button
              self.addToCartButton.attr('disabled', 'disabled').addClass('disabled-btn');
              $('.pdp-sticky-atc').attr('disabled', 'disabled').addClass('disabled-btn');
            }
          }

          if (SDG.disableGwpSection) SDG.disableGwpSection();
        });
      }).catch(function(error) {
        const response = error.responseJSON;
        if (response && response.status === 422 && response.message) {
          self.addToCartButton.removeAttr('disabled').removeClass('button--loading');
          $(".server-msg .message").text(response.message)
          $(".server-msg").show();
          if (typeof scrollPdpErrorIfVisible === 'function') {
            scrollPdpErrorIfVisible(document.querySelector('.server-msg.error'));
          }
          return;
        }

        // If there is an error while adding (usually if all products are added to the cart), we temporarily
        // display the message from Shopify, and then revert to the original message after 2 seconds
        $(".non-rlc-btn").removeClass('button--loading').addClass("sold-out-btn").attr("disabled", "disabled").text("SOLD OUT");
        $(".pdp-sticky-atc").removeClass('button--loading pdp-sticky-atc--loading').addClass("sold-out-btn").attr("disabled", "disabled").text("SOLD OUT");
      });

    }

    function updateItemQty(itemData, customQuantity) {
      const dataObj = {
        id: itemData.key.toString(),
        quantity: itemData.quantity + (customQuantity || 1),
      };

      $.ajax({
        method: 'POST',
        url: Shopify.routes.root + 'cart/change.js',
        dataType: 'json',
        data: dataObj
      }).then(function() {
        $.ajax({
          method: 'GET',
          url: Shopify.routes.root + 'cart.js',
          dataType: 'json',
        }).then(function(cart) {
          return $.ajax({
            method: 'GET',
            url: Shopify.routes.root + 'cart?view=data',
            dataType: 'json',
          }).then(function(items) {
            window.SDG.Data.bagItems = Array.isArray(items) ? items : cart.items;
            return cart;
          }, function() {
            window.SDG.Data.bagItems = cart.items;
            return cart;
          });
        }).then(function(cart) {
          var lineItems = window.SDG.Data.bagItems;
          if (Array.isArray(lineItems)) {
            cart.items = lineItems;
          }
          var crAllowLimit = null;
          if (typeof addtoBtn.attr('allow-limit') !== 'undefined' && addtoBtn.attr('allow-limit') != null) {
            var maxLimit = parseInt($('#product_limit').val(), 10) || SDG.Data.productQtyLimit || parseInt(addtoBtn.attr('allow-limit'), 10);
            var productHandle = SDG.Data.productHandle || (window.location && window.location.pathname.replace('/products/', ''));
            var totalSameProductQty = (cart.items || []).filter(function(item) { return item.handle === productHandle; }).reduce(function(sum, i) { return sum + (i.quantity || 0); }, 0);
            crAllowLimit = Math.max(0, maxLimit - totalSameProductQty);
            addtoBtn.attr('allow-limit', crAllowLimit);
          }

          if (crAllowLimit !== null && crAllowLimit <= 0) {
            errorMsg();
          }

          // Without this the mini-cart has nothing to reveal and falls back to
          // showing its first line, which is not the item this call changed.
          var changedVariantId = itemData.id != null ? itemData.id : itemData.variant_id;
          if (changedVariantId != null) {
            window.SDG.Data.itemsAddedToCart = [{ id: changedVariantId }];
          }

          $(document).trigger('theme:cart:updated', [cart, true, true]);
          var cartCount = $(".header__cart-count:first").text().trim();
          if(cartCount!="0"){
            $(".header__cart-count").css("display","block");
          }else{
            $(".header__cart-count").css("display","none");
          }
          self.addToCartButton.removeAttr('disabled').removeClass('button--loading');
          if ($(".non-rlc-btn")[0]){
            //$( "#non-rlc-container" ).load(window.location.href + " #non-rlc-container" );
          }
        });
      }).catch(function(error) {
        // If there is an error while adding (usually if all products are added to the cart), we temporarily
        // display the message from Shopify, and then revert to the original message after 2 seconds
        $(".non-rlc-btn").removeClass('button--loading').addClass("sold-out-btn").attr("disabled", "disabled").text("SOLD OUT");
        $(".pdp-sticky-atc").removeClass('button--loading pdp-sticky-atc--loading').addClass("sold-out-btn").attr("disabled", "disabled").text("SOLD OUT");
      }); // end of ajax function here
    }

    if ($membershipsSelect) {
      const selectedMembership = $membershipsSelect.value;
      if (selectedMembership === '' && !$membershipsSelect.disabled) {
        const $membershipError = document.querySelector('.js-membership-error');
        const $trigger = document.querySelector('.js-memberships-trigger');
        if ($membershipError) {
          $membershipError.classList.remove('hide');
          if (typeof scrollPdpErrorIfVisible === 'function') scrollPdpErrorIfVisible($membershipError);
        }
        if ($trigger) $trigger.classList.add('error');
        event.preventDefault();
        return;
      }
    }

    if(typeof addtoBtn.attr('allow-limit') != 'undefined' ||  addtoBtn.attr('allow-limit') != null){
      allowLimit = addtoBtn.attr('allow-limit');
      allowLimit = parseInt(allowLimit);
      limitCheck = true;
    }
    if (event.target.classList.contains('raffle')) {
      return;
    }

    if (SDG.Data.exclusiveBrand) {
      SDG.Data.exclusivePdpChecked = $('.upsell-container .checkbox-group input[type="checkbox"]:checked').length;
    }
    const isSizedProduct = self.addToCartButton === 'productSizeSubmit';
    let noSizeSelected = false;
    let hasLegacyMembershipUpsell = false;

    if (isSizedProduct && $('#sizeList').length > 0) {
      noSizeSelected = $('#sizeList input:checked').length > 0 ? false : true;
    }

    if ($(".digital-memb").length) {
      const isChecked = $(".digital-memb").is(":checked");
      const isDisabled = $(".digital-memb").is(":disabled");
      const isDigitalMembership = SDG?.Data?.isDigitalMembership && !$(".grid__membership-upsell").length;
      const isExclusiveMember = typeof SDG?.Data?.isExclusiveMember === 'string' ? SDG?.Data?.isExclusiveMember?.split(',').includes(SDG?.Data?.exclusiveBrand) : SDG?.Data?.isExclusiveMember;
      const isExclusiveCustomer = SDG?.Data?.isCustomer && isExclusiveMember;
      hasLegacyMembershipUpsell = true;

      const shouldApplyErrorStyles =
        !isChecked &&
        !isDisabled &&
        !isDigitalMembership &&
        (!SDG?.Data?.isCustomer || !isExclusiveCustomer);

      if (shouldApplyErrorStyles) {
        const closestParentGrid = $(".digital-memb").closest(".grid");
        closestParentGrid.css("border", "1px solid #ee0224");
        $(".product__membership-error").removeClass("hide").each(function () {
          if (typeof scrollPdpErrorIfVisible === 'function') scrollPdpErrorIfVisible(this);
        });
        $(".product__add-to-cart").addClass("atc-error-color");
        $(".membership-agreement").css({
          "display": "none",
        });
        $(".digital-memb").siblings("label").css({
          "background": "none",
          "border": "1px solid red"
        });
        return;
      }
    }

    const closestParentGrid = $(".digital-memb").closest(".grid");
    closestParentGrid.css("border", "1px solid #7b7b7b");
    $(".product__membership-error").addClass("hide");

    if (isSizedProduct && !noSizeSelected) return;

    if(limitCheck){
      if(allowLimit > btnHit){
        if(allowLimit !=0){
          let termsClass = document.querySelector("#accept-terms-conditions");
          if(termsClass && !hasLegacyMembershipUpsell){
            if(termsClass.checked || ($membershipsSelect && membershipSelectDisabled)){
              addCode(btnHit,allowLimit);
            }else{
              const $membershipAgreeError = document.querySelector('.warning-msg.membership-agreement');
              const $checkboxContainer = document.querySelector('.checkbox-container');
              if ($membershipAgreeError) {
                $membershipAgreeError.style.display = 'flex';
                if (typeof scrollPdpErrorIfVisible === 'function') {
                  scrollPdpErrorIfVisible($membershipAgreeError);
                }
              }
              if ($checkboxContainer) {
                $checkboxContainer.classList.add('error');
              }
            }
          }
          else{
            addCode(btnHit,allowLimit);
          }
        }
        else{
          errorMsg();
        }
      }else if(isNaN(allowLimit)){
        addCode();
      }
      else{
        errorMsg();
      }
    }
    else{
      let termsClass = document.querySelector("#accept-terms-conditions");
      const digitalMembInput = document.querySelector('.digital-memb');
      const digitalMembInputDisabled = digitalMembInput ? digitalMembInput.disabled : false;
      if(termsClass){
        if(termsClass.checked || digitalMembInputDisabled || ($membershipsSelect && membershipSelectDisabled)){
          addCode();
        } else {
          const $membershipAgreeError = document.querySelector('.warning-msg.membership-agreement');
          const $checkboxContainer = document.querySelector('.checkbox-container');
          if ($membershipAgreeError) {
            $membershipAgreeError.style.display = 'flex';
            if (typeof scrollPdpErrorIfVisible === 'function') {
              scrollPdpErrorIfVisible($membershipAgreeError);
            }
          }
          if ($checkboxContainer) {
            $checkboxContainer.classList.add('error');
          }
        }
      }
      else{
        addCode();
      }
    }
    // First, we switch the status of the button to display the spinner

    event.preventDefault();
  };

  $.fn[pluginName] = function(options) {
    var method = false,
      methodArgs = arguments;

    if (typeof options == 'string') {
      method = options;
    }

    return this.each(function() {
      var plugin = $.data(this, namespace);

      if (!plugin && !method) {
        $.data(this, namespace, new Plugin(this, options));
      } else if (method) {
        callMethod(plugin, method, Array.prototype.slice.call(methodArgs, 1));
      }
    });
  };
}(jQuery));
/**
 * Plugin to handle tabs
 */

(function ($) {

  'use strict';

  var pluginName = 'trademarkTabs',
    namespace = 'plugin_' + pluginName;

  /**
   * The Plugin constructor
   */
  function Plugin(element, options) {
    this.element = $(element);
    this.navItems = this.element.find('.tabs__nav-item');
    this.content = this.element.find('.tabs__content');
    this.contentItems = this.content.find('.tabs__content-item');

    this.navItems.on('click', $.proxy(this._changeTab, this));

    var tabsNav = this.element.find('.tabs__nav-inner'),
      tabsNavElem = tabsNav.get(0);

    tabsNavElem.classList[tabsNavElem.scrollWidth - tabsNavElem.clientWidth - tabsNavElem.scrollLeft > 20 ? 'add' : 'remove']('tabs__nav-inner--shadowed-right');

    tabsNav.on('scroll', function() {
      this.classList[this.scrollLeft > 20 ? 'add' : 'remove']('tabs__nav-inner--shadowed-left');
      this.classList[this.scrollWidth - this.clientWidth - this.scrollLeft > 20 ? 'add' : 'remove']('tabs__nav-inner--shadowed-right');
    });
  }

  Plugin.prototype.destroy = function() {
    this.navItems.off('click');

    this.element.removeData('plugin_trademarkTabs');
  };

  Plugin.prototype._changeTab = function(event) {
    var target = $(event.target),
      currentItem = this.contentItems.filter('.tabs__content-item--active'),
      newItem = this.contentItems.eq(target.index()),
      self = this;

    // Set the current height to the container, so that animation can be done
    this.content.css('height', currentItem.height());

    // Change the active nav item
    target.siblings().removeClass('tabs__nav-item--active').end().addClass('tabs__nav-item--active');

    currentItem.removeClass('tabs__content-item--active');
    newItem.addClass('tabs__content-item--active');

    // Set the height of the new item for the parent to trigger CSS3 animation
    this.content.css('height', newItem.height());

    // Then, make sure to remove the hard-coded height to allow change in height inside the container
    if (Modernizr.cssanimations) {
      this.content.one('webkitAnimationEnd animationend', function() {
        self.content.css('height', '');
      });
    } else {
      this.content.css('height', '');
    }

    event.preventDefault();
  };

  $.fn[pluginName] = function(options) {
    var method = false,
      methodArgs = arguments;

    if (typeof options == 'string') {
      method = options;
    }

    return this.each(function() {
      var plugin = $.data(this, namespace);

      if (!plugin && !method) {
        $.data(this, namespace, new Plugin(this, options));
      } else if (method) {
        callMethod(plugin, method, Array.prototype.slice.call(methodArgs, 1));
      }
    });
  };
}(jQuery));
/**
 * Plugin to handle all the dynamic features of a product
 */

(function ($) {

  'use strict';

  var pluginName = 'valuePicker',
    namespace = 'plugin_' + pluginName;

  /**
   * The Plugin constructor
   * @constructor
   * @param {HTMLElement} element The element that will be monitored
   * @param {object} options The plugin options
   */
  function Plugin(element, options) {
    $(document).on('click', '[data-action="open-value-picker"]', this._toggleValuePicker.bind(this));
    $(document).on('click', '[data-action="close-value-picker"]', this._closeValuePicker.bind(this));
  }

  Plugin.prototype._toggleValuePicker = function(event) {
    var $target = $(event.currentTarget),
      isClosed = ($target.attr('aria-expanded') === 'false');

    $target.attr('aria-expanded', isClosed ? 'true' : 'false');
    $('#' + $target.attr('aria-controls')).attr('aria-hidden', isClosed ? 'false' : 'true');

    // If it's now open, we attach a listener to detect if we loose the focus
    if ($target.attr('aria-expanded') === 'true') {
      var closestWrapper = $target.closest('.value-picker-wrapper'),
        self = this;

      closestWrapper.on('focusout', function(event) {
        if (!closestWrapper.get(0).contains(event.relatedTarget)) {
          self._closeByValueWrapper($(event.currentTarget));
        }
      });
    }
  };

  Plugin.prototype._closeValuePicker = function(event) {
    var $target = $(event.currentTarget);
    $('[data-action="open-value-picker"][aria-controls="' + $target.attr('aria-controls') + '"]').attr('aria-expanded', 'false');
    $('#' + $target.attr('aria-controls')).attr('aria-hidden', 'true');
  };

  Plugin.prototype._closeByValueWrapper = function(target) {
    target.find('[data-action="open-value-picker"]').attr('aria-expanded', 'false');
    target.find('.value-picker').attr('aria-hidden', 'true');
    target.off('focusout');
  };

  /**
   * Init the plugin
   */
  Plugin.prototype._init = function() {
  };

  $.fn[pluginName] = function(options) {
    var method = false,
      methodArgs = arguments;

    if (typeof options == 'string') {
      method = options;
    }

    return this.each(function() {
      var plugin = $.data(this, namespace);

      if (!plugin && !method) {
        $.data(this, namespace, new Plugin(this, options));
      } else if (method) {
        callMethod(plugin, method, Array.prototype.slice.call(methodArgs, 1));
      }
    });
  };
}(jQuery));

var router = new RouterRouter();

router.route('*all', function() {
  var bodyElement = $('body');

  /**
   * -------------------------
   * VALUE PICKER
   * -------------------------
   */

  $(document).valuePicker();

  /**
   * -------------------------
   * STICKY HEADER POLYFILL AND HEADER SIZE
   * -------------------------
   */

  (function() {
    var headerSection = $('.shopify-section__header');

    Stickyfill.add(headerSection.get(0));
    $('.anchor').css('top', -headerSection.height());

    $(document).on('shopify:section:unload', '#shopify-section-header', function(event) {
      Stickyfill.remove(event.target);
    });

    $(document).on('shopify:section:load', '#shopify-section-header', function(event) {
      Stickyfill.add(event.target);
    });
  }());

  /**
   * -------------------------
   * MOBILE/TABLET NAVIGATION
   * -------------------------
   */

  (function() {
    $('.sidebar-nav').trademarkMobileSidebar();

    $(document).on('shopify:section:unload', '#shopify-section-header', function(event) {
      $(event.target).find('.sidebar-nav').data('plugin_trademarkMobileSidebar').destroy();
    });

    $(document).on('shopify:section:load', '#shopify-section-header', function(event) {
      $(event.target).find('.sidebar-nav').trademarkMobileSidebar();
    });
  }());

  /**
   * -------------------------
   * MAIN NAVIGATION (ACCESSIBILITY)
   * -------------------------
   */

  (function() {
    $('.header__main-nav').trademarkMainNav();

    $(document).on('shopify:section:unload', '#shopify-section-header', function(event) {
      $(event.target).find('.header__main-nav').data('plugin_trademarkMainNav').destroy();
    });

    $(document).on('shopify:section:load', '#shopify-section-header', function(event) {
      $(event.target).find('.header__main-nav').trademarkMainNav();
    });
  }());

  /**
   * -------------------------
   * MINI-CART
   * -------------------------
   */

  (function() {

      $('.js-mini-cart').trademarkMiniCart();

      $(document).on('shopify:section:unload', '#shopify-section-header', function(event) {
        $(event.target).find('.js-mini-cart').data('plugin_trademarkMiniCart').destroy();
      });

      $(document).on('shopify:section:load', '#shopify-section-header', function(event) {
        $(event.target).find('.js-mini-cart').trademarkMiniCart();
      });
  }());

  /**
   * -------------------------
   * SEARCH
   * Note that search initialization must happen after mini-cart and sidebar, as it relies on the existence of those two
   * -------------------------
   */

  // moving to SS

  // (function() {
  //   $('.header-search').trademarkHeaderSearch();

  //   $(document).on('shopify:section:unload', '#shopify-section-header', function(event) {
  //     $(event.target).find('.header-search').data('plugin_trademarkHeaderSearch').destroy();
  //   });

  //   $(document).on('shopify:section:load', '#shopify-section-header', function(event) {
  //     $(event.target).find('.header-search').trademarkHeaderSearch();
  //   });
  // }());

  /**
   * -------------------------
   * RTE (FOR PAGE THAT CONTAINED USER DEFINED TEXT, WE DO SOME POST-PROCESSING
   * -------------------------
   */

  (function() {
    // 1st: wrap tables
    $('.rte table').addClass('table').wrap('<div class="table-wrapper"></div>');

    // 2nd: wrap videos
    var iframeVideo = $('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]');
    var iframeReset = iframeVideo.add('.rte iframe#admin_bar_iframe');

    iframeVideo.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="video-wrapper"></div>');
    });

    iframeReset.each(function() {
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }());

  /**
   * -------------------------
   * FEATURED COLLECTIONS
   * -------------------------
   */

  (function() {
    if (!Modernizr.touchevents || Modernizr.mq('(min-width: 1024px)')) {
      bodyElement.on('mouseenter mouseleave', '.collection-item', function() {
        $(this).toggleClass('collection-item--hovered').find('.collection-item__bottom').slideToggle({duration: 250});
      });
    }
  }());

  /**
   * ----------------------------
   * FEATURED MAP
   * ----------------------------
   */

  (function() {
    $('.featured-map').trademarkMap();

    $(document).on('shopify:section:load', '.shopify-section__featured-map', function(event) {
      $(event.target).find('.featured-map').trademarkMap();
    });

    $(document).on('shopify:section:unload', '.shopify-section__featured-map', function(event) {
      $(event.target).find('.featured-map').data('plugin_trademarkMap').destroy();
    });
  }());

  /**
   * -------------------------
   * TWITTER
   * -------------------------
   */

  (function() {
    var initTwitter = function(domElement) {
      if (domElement.length === 0) {
        return;
      }

      window.twttr = (function(d, s, id) {var js, fjs = d.getElementsByTagName(s)[0], t = window.twttr || {}; if (d.getElementById(id)) return t; js = d.createElement(s);
        js.id = id; js.src = "https://platform.twitter.com/widgets.js"; fjs.parentNode.insertBefore(js, fjs); t._e = []; t.ready = function(f) {t._e.push(f);};
        return t;
      }(document, "script", "twitter-wjs"));

      var twitterHandle = domElement.attr('data-twitter-handle');

      twttr.ready(function () {
        twttr.widgets.createTimeline(
          {
            sourceType: 'profile',
            screenName: twitterHandle
          },
          document.getElementById('twitter-timeline'),
          {
            tweetLimit: 1,
            lang: window.theme.locale || 'en',
            chrome: 'noheader nofooter noborders transparent noscrollbar'
          }
        ).then(function (result) {
          // Twitter return the results in an iframe, so we need to parse the code to extract what we want

          var content = $(result).contents(),
            twitterModule = $('.tweet');

          twitterModule.find('.tweet__content').html(content.find('.timeline-Tweet-text'));
          twitterModule.find('.tweet__date').text(content.find('.timeline-Tweet-timestamp .dt-updated').attr('aria-label'));
        });
      });
    };

    initTwitter($('.footer [data-twitter-handle]'));

    $(document).on('shopify:section:load', '#shopify-section-footer', function(event) {
      initTwitter($(event.target).find('[data-twitter-handle]'));
    });
  }());

  /**
   * -------------------------
   * MARKETING POPUP
   * -------------------------
   */

  (function() {
    var popupModalInstance = null;

    var initPopup = function(element) {
      if (element.length === 0 || Modernizr.mq('(max-width: 559px)')) {
        return;
      }

      popupModalInstance = element.remodal({
        hashTracking: (window.theme.template !== null),
        appendTo: '#shopify-section-popup'
      });

      setTimeout(function() {
        // We save into the cookie in order to avoid annoying the user
        if (popupModalInstance.getState() === 'closed' && !$.cookie('theme_popup_seen') && element.attr('data-visible') === 'true') {
          popupModalInstance.open();
        }

        $.cookie('theme_popup_seen', true, {expires: parseInt(element.attr('data-remember-me')) });
      }, parseInt(element.attr('data-delay')));
    };

    initPopup($('.promotion-popup'), false);

    $(document).on('shopify:section:select', '#shopify-section-popup', function() {
      if (popupModalInstance && popupModalInstance.getState() !== 'opened') {
        popupModalInstance.open();
      }
    });

    $(document).on('shopify:section:deselect', '#shopify-section-popup', function() {
      if (popupModalInstance) {
        popupModalInstance.close();
      }
    });

    $(document).on('shopify:section:load', '#shopify-section-popup', function(event) {
      initPopup($(event.target).find('.promotion-popup'));
    });
  })();

  /**
   * -------------------------
   * FAQ PAGE (we can't know in advance the exact URLs, so those are handled here as well)
   * -------------------------
   */

  (function() {
    bodyElement.on('click', '.faq__question', function() {
      $(this).next('.faq__answer').slideToggle(150);
    });

    $(document).on('shopify:block:select', '#shopify-section-page-faq-template', function(event) {
      $(event.target).find('.faq__answer').slideDown(150);
    });

    $(document).on('shopify:block:deselect', '#shopify-section-page-faq-template', function(event) {
      $(event.target).find('.faq__answer').slideUp(150);
    });
  }());
});
router.route('(:lang/)blogs/*blog/*article', function() {
  /**
   * -------------------------
   * STICKY SHARE BUTTONS
   * -------------------------
   */

  (function() {
    var header = $('#shopify-section-header'),
      shareButtons = $('.article__body .share-buttons');

    shareButtons.css('top', header.height() + 20);
    shareButtons.Stickyfill();
  }());
});
router.route('(:lang/)blogs/*blog', function() {
});
router.route('(:lang/)cart', function() {
  /**
   * -------------------------
   * CART NOTE
   * -------------------------
   */

  $('.js-cart-note').on('change', function() {
    $.ajax({
      method: 'POST',
      url: Shopify.routes.root + 'cart/update.js',
      data: {
        note: $(this).val()
      },
      dataType: 'json'
    });
  });

  /**
   * -------------------------
   * SHIPPING ESTIMATOR
   * -------------------------
   */

  (function() {
    var initShippingEstimator = function() {
      var shippingEstimator = $('.shipping-estimator');

      // If the estimator has been disabled, we do not need to attach all the other listeners
      if (shippingEstimator.length === 0) {
        return;
      }

      var shippingEstimatorForm = shippingEstimator.find('.shipping-estimator__form'),
        shippingEstimatorSubmit = shippingEstimator.find('.shipping-estimator__submit'),
        shippingEstimatorResults = shippingEstimator.find('.shipping-estimator__results'),
        shippingEstimatorList = shippingEstimatorResults.find('.shipping-estimator__list'),
        cartEstimatedShipping = $('.js-cart-shipping');

      $('.shipping-estimator--mobile .shipping-estimator__title').on('click', function() {
        $(this).next('.shipping-estimator__inner').slideToggle();
        $(this).closest('.shipping-estimator').toggleClass('shipping-estimator--active');
      });

      var submitShippingEstimatorForm = function(event) {
        shippingEstimatorSubmit.text(window.languages.shippingEstimatorSubmitting);

        $.ajax({
          method: 'GET',
          url: Shopify.routes.root + 'cart/shipping_rates.json',
          data: $(event.currentTarget).closest('.shipping-estimator__form').find('input, select').serialize(),
          success: function(results) {
            shippingEstimatorList.empty();

            results['shipping_rates'].forEach(function(item) {
              var amount = Shopify.formatMoney(item['price'] * 100, window.theme.moneyFormat);
              shippingEstimatorList.append('<li class="shipping-estimator__item">' + item['name'] + ': <span data-money-convertible>' + amount + '</span></li>');
            });

            if (results['shipping_rates'].length > 0) {
              var firstPrice = Shopify.formatMoney(results['shipping_rates'][0]['price'] * 100, window.theme.moneyFormat);
              cartEstimatedShipping.html(window.languages.cartEstimatedShipping + ' ' + firstPrice);
            }
          },
          error: function(results) {
            shippingEstimatorList.empty();

            var response = results.responseJSON,
              errors = [];

            for (var key in response) {
              if (response.hasOwnProperty(key)) {
                errors.push({key: key, value: response[key][0]});
              }
            }

            errors.forEach(function(item) {
              shippingEstimatorList.append('<li class="shipping-estimator__item">' + item['key'] + ': ' + item['value'] + '</li>');
            });
          },
          complete: function(results) {
            shippingEstimatorSubmit.html(window.languages.shippingEstimatorSubmit);
            shippingEstimatorResults.show();
          }
        });

        event.preventDefault();
      };

      shippingEstimatorForm.on('keypress', function(event) {
        // If Enter is press, we submit the form
        if (event.keyCode == 13) {
          submitShippingEstimatorForm(event);
        }
      });

      $('.shipping-estimator__submit').on('click', function(event) {
        submitShippingEstimatorForm(event);
      });

      new Shopify.CountryProvinceSelector('address_country', 'address_province', {hideElement: 'address_province_container'});
      new Shopify.CountryProvinceSelector('address_country_mobile', 'address_province_mobile', {hideElement: 'address_province_container_mobile'});
    };

    initShippingEstimator();

    $(document).on('shopify:section:load', '#shopify-section-cart-template', function() {
      initShippingEstimator();
    });
  }());

  /**
   * -------------------------
   * RECOMMENDED PRODUCTS
   * -------------------------
   */

  (function() {
    var initProducts = function(domElement) {
      if (domElement.length === 0) {
        return;
      }

      domElement.slick({
        accessibility: false,
        dots: true,
        dotsClass: 'slider-dots',
        arrows: false,
        adaptiveHeight: true,
        mobileFirst: true,
        infinite: false,
        centerMode: true,
        centerPadding: '32px',
        slidesToShow: 1,
        initialSlide: Math.ceil(domElement.attr('data-slides-count') / 2) - 1,
        responsive: [
          {
            breakpoint: 560,
            settings: 'unslick'
          }
        ]
      })
    };

    initProducts($('.list-products'));

    $(document).on('shopify:section:unload', '.shopify-section__cart-related-products', function(event) {
      $(event.target).find('.list-products').slick('unslick');
    });

    $(document).on('shopify:section:load', '.shopify-section__cart-related-products', function(event) {
      initProducts($(event.target).find('.list-products'));
    });

    $(window).on('resize orientationChange', function() {
      if (window.innerWidth < 560) {
        // If not created yet, we create it
        var slick = $('.list-products');

        if (slick.slick('getSlick').unslicked) {
          initProducts(slick);
        }
      }
    });
  }());
});
router.route('(:lang/)collections/*type', function() {
  /**
   * -------------------------
   * SORT BY AND SEARCH
   * -------------------------
   */

  (function() {
    Shopify.queryParams = {};

    var bindFilters = function() {
      $('#collection-sort-by').on('change', function () {
        Shopify.queryParams.sort_by = $(this).val();
        location.search = $.param(Shopify.queryParams);
      });

      if (location.search.length) {
        for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
          aKeyValue = aCouples[i].split('=');

          if (aKeyValue.length > 1) {
            Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
          }
        }
      }

      $('#collection-tag-filter, #collection-type-filter').on('change', function (event) {
        window.location.href = $(event.currentTarget).find(':selected').val();
      });
    };

    bindFilters();

    $(document).on('shopify:section:load', function(event) {
      bindFilters();
    });
  }());
});
/**
 * ----------------------------------------------------------------------------------------------------
 * GIFT CARDS
 * ----------------------------------------------------------------------------------------------------
 */

router.route('(:lang/)gift_cards/*id', function() {
  (function() {
    var config = {
      qrCode: '#QrCode',
      printButton: '#PrintGiftCard',
      giftCardCode: '#GiftCardDigits'
    };

    var $qrCode = $(config.qrCode);

    new QRCode($qrCode[0], {
      text: $qrCode.attr('data-identifier'),
      width: 175,
      height: 175
    });

    $(config.printButton).on('click', function() {
      window.print();
    });

    // Auto-select gift card code on click, based on ID passed to the function
    $(config.giftCardCode).on('click', {element: 'GiftCardDigits'}, selectText);

    function selectText(evt) {
      var text = document.getElementById(evt.data.element);
      var range = '';

      if (document.body.createTextRange) {
        range = document.body.createTextRange();
        range.moveToElementText(text);
        range.select();
      } else if (window.getSelection) {
        var selection = window.getSelection();
        range = document.createRange();
        range.selectNodeContents(text);
        selection.removeAllRanges();
        selection.addRange(range);
      }
    }
  }());
});
router.route('(:lang)', function(pattern) {
  if (pattern === 'search') {
    return;
  }

  /**
   * -------------------------
   * SLIDESHOW
   * -------------------------
   */

  (function() {
    var initFullScreenSlideshow = function(slideshow) {
      var slidesCount = slideshow.next('.fs-slideshow__slide-count'),
        slideshowProgressBarAdvancement = slideshow.nextAll('.fs-slideshow__progress-bar').find('.fs-slideshow__progress-bar-advancement');

      slideshow.slick({
        dots: false,
        arrow: true,
        pauseOnHover: false,
        accessibility: false,
        adaptiveHeight: true,
        useTransform: true,
        useCSS: true,
        autoplay: (slideshow.attr('data-autoplay') === 'true'),
        autoplaySpeed: parseInt(slideshow.attr('data-cycle-speed')),
        prevArrow: '<button class="fs-slideshow__nav-button fs-slideshow__nav-prev slick-prev"><svg class="icon icon-arrow-left"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-arrow-left"></use></svg></button>',
        nextArrow: '<button class="fs-slideshow__nav-button fs-slideshow__nav-next slick-next"><svg class="icon icon-arrow-right"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-arrow-right"></use></svg></button>'
      });

      slideshow.on('afterChange', function(event, slick, currentSlide) {
        if (slidesCount.length > 0) {
          slidesCount.find('.fs-slideshow__current-slide').text(currentSlide + 1); // Slick is 0-indexed
        }

        if (slideshowProgressBarAdvancement.length > 0) {
          slideshowProgressBarAdvancement.css('width', ((currentSlide + 1) / slick.slideCount * 100) + '%');
        }
      });
    };

    // Trademark has two different slideshows: a "dual" one that is quite complex and a full-screen that is simpler to implement. When this change,
    // we either init one or the other
    $('.slideshow-section').each(function(index, item) {
      var slideshowSection = $(item),
        slideshowType = slideshowSection.attr('data-slideshow-type');

      if (slideshowType === 'dual') {
        slideshowSection.find('.dual-slideshow').trademarkHomeSlideshow();
      } else {
        initFullScreenSlideshow(slideshowSection.find('.fs-slideshow__slides'));
      }
    });

    $(document).on('shopify:section:unload', '.shopify-section__slideshow', function(event) {
      var slideshowSection = $(event.target).find('.slideshow-section');

      // If previous slideshow was dual, we have to delete the plugin completely (which will free the memory)
      if (slideshowSection.attr('data-slideshow-type') === 'dual') {
        slideshowSection.find('.dual-slideshow').data('plugin_trademarkHomeSlideshow').destroy();
      } else {
        // Otherwise, logic is a bit simpler and we just call slick to delete
        slideshowSection.find('.fs-slideshow__slides').slick('unslick');
      }
    });

    $(document).on('shopify:section:load', '.shopify-section__slideshow', function(event) {
      var slideshowSection = $(event.target).find('.slideshow-section');

      // If slideshow is dual we need to instantiate the whole plugin, otherwise setup is simpler
      if (slideshowSection.attr('data-slideshow-type') === 'dual') {
        slideshowSection.find('.dual-slideshow').trademarkHomeSlideshow();
      } else {
        var slideshow = slideshowSection.find('.fs-slideshow__slides');

        initFullScreenSlideshow(slideshow);
      }
    });

    $(document).on('shopify:block:select', '.shopify-section__slideshow', function(event) {
      var slideshowSection = $(event.target).closest('.slideshow-section');

      if (slideshowSection.attr('data-slideshow-type') === 'dual') {
        var slideshow = slideshowSection.find('.dual-slideshow').data('plugin_trademarkHomeSlideshow');

        slideshow.pause();
        slideshow.goToSlide($(event.target).attr('data-slide-index'));
      } else {
        var slideshow = slideshowSection.find('.fs-slideshow__slides');

        slideshow.slick('goTo', $(event.target).attr('data-slide-index'));

        if (slideshow.attr('data-autoplay') === 'true') {
          slideshow.slick('pause');
        }
      }
    });

    $(document).on('shopify:block:deselect', '.shopify-section__slideshow', function(event) {
      var slideshowSection = $(event.target).closest('.slideshow-section');

      if (slideshowSection.attr('data-slideshow-type') === 'dual') {
        slideshowSection.find('.dual-slideshow').data('plugin_trademarkHomeSlideshow').play();
      } else {
        var slideshow = slideshowSection.find('.fs-slideshow__slides');

        if (slideshow.attr('data-autoplay') === 'true') {
          slideshow.slick('play');
        }
      }
    });
  }());

  /**
   * -------------------------
   * FEATURED COLLECTIONS
   * -------------------------
   */

  (function() {
    var initCollections = function(domElement) {
      if (domElement.length === 0) {
        return;
      }

      domElement.slick({
        accessibility: false,
        dots: true,
        dotsClass: 'slider-dots',
        arrows: false,
        mobileFirst: true,
        infinite: false,
        centerMode: true,
        centerPadding: '32px',
        initialSlide: Math.ceil(domElement.attr('data-slides-count') / 2) - 1,
        slidesToShow: 1,
        responsive: [
          {
            breakpoint: 560,
            settings: 'unslick'
          }
        ]
      })
    };

    initCollections($('.list-collections'));

    $(document).on('shopify:section:unload', '.shopify-section__collection-list', function(event) {
      $(event.target).find('.list-collections').slick('unslick');
    });

    $(document).on('shopify:section:load', '.shopify-section__collection-list', function(event) {
      initCollections($(event.target).find('.list-collections'));
    });

    $(document).on('shopify:block:select', '.shopify-section__collection-list', function(event) {
      $(event.target).closest('.list-collections').slick('slickGoTo', $(event.target).attr('data-slide-index'));
    });

    $(window).on('resize orientationChange', function() {
      if (window.innerWidth < 560) {
        // If not created yet, we create it
        var slick = $('.list-collections');

        if (slick.slick('getSlick').unslicked) {
          initCollections(slick);
        }
      }
    });
  }());

  /**
   * -------------------------
   * FEATURED PRODUCTS
   * -------------------------
   */

  (function() {
    var initProducts = function(domElement) {
      if (domElement.length === 0) {
        return;
      }

      domElement.slick({
        accessibility: false,
        dots: true,
        dotsClass: 'slider-dots',
        arrows: false,
        adaptiveHeight: true,
        mobileFirst: true,
        infinite: false,
        centerMode: true,
        centerPadding: '32px',
        slidesToShow: 1,
        initialSlide: Math.ceil(domElement.attr('data-slides-count') / 2) - 1,
        responsive: [
          {
            breakpoint: 560,
            settings: 'unslick'
          }
        ]
      })
    };

    initProducts($('.list-products'));

    $(document).on('shopify:section:unload', '.shopify-section__featured-collection', function(event) {
      $(event.target).find('.list-products').slick('unslick');
    });

    $(document).on('shopify:section:load', '.shopify-section__featured-collection', function(event) {
      initProducts($(event.target).find('.list-products'));
    });

    $(window).on('resize orientationChange', function() {
      if (window.innerWidth < 560) {
        // If not created yet, we create it
        var slick = $('.list-products');

        if (slick.slick('getSlick').unslicked) {
          initProducts(slick);
        }
      }
    });
  }());
});
/**
 * ----------------------------------------------------------------------------------------------------
 * LOGIN
 * ----------------------------------------------------------------------------------------------------
 */

router.route('(:lang/)account/login', function() {
  /**
   * -------------------------
   * SWITCH TO RECOVER FORM
   * -------------------------
   */

  (function() {
    var switchToRecoverForm = function() {
      $('#login-section, #recover-password-section').toggle();
      $('.page__title').text(window.languages.recoverPasswordTitle);
    };

    $('[data-action="display-recover-form"]').on('click', function() {
      switchToRecoverForm();
      return false;
    });

    // We also switch if we directly have the hash "recover"
    if (window.location.hash === '#recover' || window.recoverPassword === true) {
      switchToRecoverForm();
    }
  }());
});
router.route('(:lang/)password', function() {
  (function() {
    var passwordModal = $('.password-popup');

    $('[data-action="toggle-storefront-password"]').on('click', function() {
      passwordModal.remodal({hashTracking: false}).open();
    });
  })();
});
/**
 * ----------------------------------------------------------------------------------------------------
 * PRODUCT ROUTE
 * ----------------------------------------------------------------------------------------------------
 */

var productRoute = function() {
  /**
   * -------------------------
   * PRODUCT SLIDESHOW
   * -------------------------
   */

  (function() {
    var initProductSlideshow = function(domElement) {
      if (domElement.length === 0) {
        return;
      }

      var productSlideshow = domElement;
      var productSlides = productSlideshow.find('.product__slides');
      var productThumbnails = domElement.find('.product__thumbnails');
      var numberOfSlides = productSlides.find('.product__slide').length;

      // We keep track of each media, indexed by ID
      var mediaList = {};

      /**
       * Let's first handle 3D models
       */
      var productModels = productSlides.find('.product__slide--model');
      var hasLoadedModels = false;

      if (productModels.length > 0) {
        // We first load the CSS for the model viewer
        var stylesheet = document.createElement('link');
        stylesheet.rel = 'stylesheet';
        stylesheet.href = 'https://cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui.css';
        document.head.appendChild(stylesheet);

        // Then we use the loadFeatures and initialize the model
        window.Shopify.loadFeatures([{
          name: 'model-viewer-ui',
          version: '1.0',
          onLoad: function() {
            productModels.each(function(index, item) {
              var modelViewer = item.querySelector('model-viewer');
              mediaList[item.getAttribute('data-media-id')] = new window.Shopify.ModelViewerUI(modelViewer);

              modelViewer.addEventListener('shopify_model_viewer_ui_toggle_play', function() {
                productSlides.slick('slickSetOption', 'draggable', false);
                productSlides.slick('slickSetOption', 'touchMove', false);
                productSlides.slick('slickSetOption', 'swipe', false);
              });

              modelViewer.addEventListener('shopify_model_viewer_ui_toggle_pause', function() {
                productSlides.slick('slickSetOption', 'draggable', true);
                productSlides.slick('slickSetOption', 'touchMove', true);
                productSlides.slick('slickSetOption', 'swipe', true);
              });
            });

            hasLoadedModels = true;
          }
        }, {
          name: 'shopify-xr',
          version: '1.0',
        }]);
      }

      /**
       * Then handle native video
       */
      var productNativeVideos = productSlides.find('.product__slide--video-native'),
        hasLoadedNativeVideos = false;

      if (productNativeVideos.length > 0) {
        // Load the CSS
        var stylesheet = document.createElement('link');
        stylesheet.rel = 'stylesheet';
        stylesheet.href = 'https://cdn.shopify.com/shopifycloud/shopify-plyr/v1.0/shopify-plyr.css';
        document.head.appendChild(stylesheet);

        // Load the feature and set the video
        window.Shopify.loadFeatures([{
          name: 'video-ui',
          version: '1.0',
          onLoad: function() {
            productNativeVideos.each(function(index, item) {
              var player = new Shopify.Plyr(item.querySelector('video'), {
                controls: [
                  'play',
                  'progress',
                  'mute',
                  'volume',
                  'play-large',
                  'fullscreen'
                ],
                loop: {active: (productSlideshow.attr('data-enable-video-looping') === 'true')},
                hideControlsOnPause: true,
                iconUrl: '//cdn.shopify.com/shopifycloud/shopify-plyr/v1.0/shopify-plyr.svg',
                tooltips: {
                  controls: false,
                  seek: true
                }
              });

              player.on('play', function() {
                productSlides.slick('slickSetOption', 'draggable', false);
                productSlides.slick('slickSetOption', 'touchMove', false);
                productSlides.slick('slickSetOption', 'swipe', false);
              });

              player.on('pause', function() {
                productSlides.slick('slickSetOption', 'draggable', true);
                productSlides.slick('slickSetOption', 'touchMove', true);
                productSlides.slick('slickSetOption', 'swipe', true);
              });

              mediaList[item.getAttribute('data-media-id')] = player;
            });

            hasLoadedNativeVideos = true;
          }
        }]);
      }

      /**
       * And finally the YouTube videos
       */
      var productExternalVideos = productSlides.find('.product__slide--external-video'),
        hasLoadedExternalVideos = false;

      if (productExternalVideos.length > 0) {
        const script = document.createElement('script');
        document.body.appendChild(script);
        script.async = true;
        script.src = '//www.youtube.com/iframe_api';
        script.onload = function() {
          var playerLoadingInterval = setInterval(() => {
            if (window.YT !== undefined && window.YT.Player !== undefined) {
              productExternalVideos.each(function(index, item) {
                var player = new YT.Player(item.querySelector('iframe'), {
                  videoId: item.getAttribute('data-video-id'),
                  events: {
                    onStateChange: (event) => {
                      if (event.data === 0 && (productSlideshow.attr('data-enable-video-looping') === 'true')) {
                        event.target.seekTo(0);
                      }
                    }
                  }
                });

                mediaList[item.getAttribute('data-media-id')] = player;
              });

              hasLoadedExternalVideos = true;

              clearInterval(playerLoadingInterval);
            }
          }, 50);
        };
      }

      productSlides.on('beforeChange', function(event, slick, currentPosition, nextPosition) {
        productThumbnails.find('.product__thumbnail').removeClass('product__thumbnail--active')
          .eq(nextPosition).addClass('product__thumbnail--active');

        // We have to do various things based on the type of the new media. First, we disable the interaction
        // of the previous media if there is one
        var currentSlide = $(slick.$slides[currentPosition]);
        const image = currentSlide.find('.product__slide-image');
        image.removeAttr('id');
        if (currentSlide.hasClass('product__slide--model')) {
          mediaList[currentSlide.attr('data-media-id')].pause();
        } else if (currentSlide.hasClass('product__slide--external-video')) {
          mediaList[currentSlide.attr('data-media-id')].pauseVideo();
        } else if (currentSlide.hasClass('product__slide--video-native')) {
          mediaList[currentSlide.attr('data-media-id')].pause();
        }

        // If the previous media was of type media, then we need to revert to default XR button
        var arButton = productSlideshow.find('[data-shopify-xr]');

        if (currentSlide.hasClass('product__slide--model')) {
          arButton.attr('data-shopify-model3d-id', arButton.attr('data-shopify-model3d-default-id'));
        }
      });

      productSlides.on('afterChange', function(event, slick, currentPosition) {
        // Then for the new media, if it's on destkop, we autoplay
        var newSlide = $(slick.$slides[currentPosition]);
        const image = newSlide.find('.product__slide-image');
        image.attr('id', 'zoomModalTrigger')
        const slideChangeEvent = new Event('pdpSlideChange');
        document.dispatchEvent(slideChangeEvent);
        // stop all videos on slide change
        $('video', slick.$slides).each(function() {
          $(this).get(0).pause();
        });

        if (Modernizr.mq('(min-width: 801px)')) {
          if (newSlide.hasClass('product__slide--model')) {
            mediaList[newSlide.attr('data-media-id')].play();
          } else if (newSlide.hasClass('product__slide--external-video')) {
            mediaList[newSlide.attr('data-media-id')].playVideo();
            newSlide.focus(); // For external video we need to put the focus manually
          } else if (newSlide.hasClass('product__slide--video-native')) {
            mediaList[newSlide.attr('data-media-id')].play();
          }
        }

        var arButton = productSlideshow.find('[data-shopify-xr]');

        // If the new media is of type model, we need to update the AR button
        if (newSlide.hasClass('product__slide--model')) {
          arButton.attr('data-shopify-model3d-id', newSlide.attr('data-media-id'));
        }

        window.dataLayer.push({
          event: 'click',
          click_type: 'alternate image',
          item_id: newSlide[0].dataset.productSku,
          item_name: newSlide[0].dataset.productName,
          item_brand: newSlide[0].dataset.productVendor,
        });
      });


      productSlides.slick({
        initialSlide: parseInt(productSlides.attr('data-initial-slide')),
        responsive: [
          {
            breakpoint: 9999,
            settings: 'unslick'
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              adaptiveHeight: true,
              infinite: false,
              arrows: false,
              dots: false,
            }
          }
        ]
      });


      // if (window.screen.width <= 767 && window.PinchZoom) {
      //   var pinchZoomEls = productSlideshow.find('.js-pinch-image');
      //   pinchZoomEls.each(function(idx, pinchZoomEl) {
      //     var pinchZoomElInstance = new window.PinchZoom.default(pinchZoomEl, {
      //       zoomOutFactor: 1,
      //       minZoom: 0.5,
      //       draggableUnzoomed: false,
      //       lockDragAxis: false,
      //       horizontalPadding: 250,
      //     });
      //     pinchZoomImages.push({
      //       el: pinchZoomEl,
      //       instance: pinchZoomElInstance,
      //       idx: Number(pinchZoomEl.getAttribute('data-slide-index') ?? 0),
      //     });
      //   });
      // }

      if (window.screen.width < 767) {
        // Update progress bar
        function updateProgressBar(currentSlide) {
          var progress = ((currentSlide + 1) / numberOfSlides) * 100;
          productSlideshow.find('.carousel-progress-bar').css('width', progress + '%');
        }

        // Initialize progress bar on first load
        updateProgressBar(parseInt(productSlides.attr('data-initial-slide')));

        // Hook into the Slick afterChange event
        productSlides.on('afterChange', function(event, slick, currentSlide) {
          updateProgressBar(currentSlide);
        });
      }

      productThumbnails.find('.product__thumbnail').on('click', function(event) {
        event.preventDefault();

        var thumbnail = $(this);

        thumbnail.addClass('product__thumbnail--active');
        thumbnail.siblings().removeClass('product__thumbnail--active');

        productSlides.slick('slickGoTo', $(this).attr('data-slide-index'));
      });

      // If image zoom is enabled we also allow to open the images in a lightbox
      if (productSlideshow.attr('data-enable-image-zoom') === 'true' && Modernizr.mq('(min-width: 801px)')) {
        // productSlides.magnificPopup({
        //   delegate: '.product__slide--image',
        //   type: 'image',
        //   gallery: {
        //     enabled: true,
        //     arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"><svg class="icon icon-arrow-%dir% mfp-prevent-close"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-arrow-%dir%"></use></svg></button>'
        //   }
        // });
      }


      // if (window.screen.width <= 767 && window.PinchZoom) {
      //   $(document).on('touch click', '#main', function(event) {
      //     // Reset pinch zooms when user taps outside of gallery
      //     pinchZoomImages.forEach(function(pinchZoomImage) {
      //       if (pinchZoomImage.instance.zoomFactor !== 1) {
      //         pinchZoomImage.instance.zoomOutAnimation();
      //       }
      //     });
      //   });
      // }
    };

    initProductSlideshow($('.product__slideshow'));

    $(document).on('shopify:section:unload', '#shopify-section-product-template', function(event) {
      $(event.target).find('.product__slides').slick('unslick');
      $(event.target).find('.product__thumbnail').off('click');
    });

    $(document).on('shopify:section:load', '#shopify-section-product-template', function(event) {
      initProductSlideshow($(event.target).find('.product__slideshow'));
    });

    // Used by PDP upsell when swapping the main gallery via AJAX.
    window.SDG = window.SDG || {};
    window.SDG.reinitProductSlideshow = function(domElement) {
      var $slideshow = domElement && domElement.jquery
        ? domElement
        : $(domElement || '.product__slideshow:not(.hide)');

      if (!$slideshow.length) return;

      $slideshow.each(function() {
        var $slides = $(this).find('.product__slides');
        if ($slides.hasClass('slick-initialized')) {
          $slides.slick('unslick');
        }
        $(this).find('.product__thumbnail').off('click');
      });

      initProductSlideshow($slideshow);
    };
  }());

  /**
   * -------------------------
   * PRODUCT TABS
   * -------------------------
   */

  (function() {
    var initProductTabs = function(domElement) {
      if (domElement.length === 0) {
        return;
      }

      domElement.trademarkTabs();
    };

    initProductTabs($('.product__tabs'));

    $(document).on('shopify:section:unload', '#shopify-section-product-template', function(event) {
      $(event.target).find('.product__tabs').data('plugin_trademarkTabs').destroy();
    });

    $(document).on('shopify:section:load', '#shopify-section-product-template', function(event) {
      initProductTabs($(event.target).find('.product__tabs'));
    });
  }());

  /**
   * -------------------------
   * PRODUCT RECOMMENDATIONS
   * -------------------------
   */

  (function() {
    var createCarousel = function(domElement) {
      domElement.slick({
        accessibility: false,
        dots: true,
        dotsClass: 'slider-dots',
        arrows: false,
        adaptiveHeight: true,
        mobileFirst: true,
        infinite: false,
        centerMode: true,
        centerPadding: '32px',
        slidesToShow: 1,
        initialSlide: (domElement.children().length / 2) - 2,
        responsive: [
          {
            breakpoint: 560,
            settings: 'unslick'
          }
        ]
      })
    };

    var initProducts = function(domElement) {
      if (domElement.length === 0) {
        return;
      }

      if (domElement.attr('data-use-recommendations') === 'true') {
        var url = '/recommendations/products?section_id=product-recommendations&limit=4&product_id=' + domElement.attr('data-product-id');
        $.ajax(url).then(function(content) {
          domElement.find('.list-products').html($(content).find('.list-products').contents());
          createCarousel(domElement.find('.list-products'));
        });
      } else {
        createCarousel(domElement.find('.list-products'));
      }
    };

    initProducts($('.product-recommendations'));

    $(document).on('shopify:section:unload', function(event) {
      $(event.target).find('.product-recommendations .list-products').slick('unslick');
    });

    $(document).on('shopify:section:load', function(event) {
      initProducts($(event.target).find('.product-recommendations'));
    });

    $(window).on('resize orientationChange', function() {
      if (window.innerWidth < 560) {
        // If not created yet, we create it
        var slick = $('.product-recommendations .list-products');

        if (slick.slick('getSlick').unslicked) {
          createCarousel(slick);
        }
      }
    });
  }());
};

router.route('(:lang/)products/*type', productRoute);
router.route('(:lang/)collections/*collection/products/*type', productRoute);
router.route('(:lang/)products_preview', productRoute);
